// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/shark.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Кастомизация полосы прокрутки */
::-webkit-scrollbar {
  width: 10px;
  /* Ширина полосы прокрутки */
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.5);
  /* Цвет фона полосы прокрутки */
  border-radius: 8px;
  /* Скругление углов фона полосы прокрутки */
}

::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.7);
  /* Цвет самой полосы прокрутки */
  border-radius: 8px;
  /* Скругление углов полосы прокрутки */
  border: 2px solid transparent;
  /* Прозрачная рамка вокруг полосы прокрутки */
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgb(255, 255, 255);
  /* Изменение цвета при наведении */
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  /* Для Chrome и Safari */
  text-rendering: optimizeLegibility;
  /* Оптимизирует четкость и читаемость текста */
  -moz-osx-font-smoothing: grayscale;
  /* Для Firefox на MacOS */
}

body {
  font-family: Arial, sans-serif;
  font-size: 16px;
  color: #333;
  min-height: 100vh;
  background: linear-gradient(1.63deg, var(--background-color) 3.46%, var(--background-color) 51.09%, var(--background-color) 96.78%);
}

#app-background {
  min-height: 100vh;
  height: 100%;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  width: 100%;
}

@media (max-width: 768px) {
  #app-background {
    background-size: cover;
  }
}
h1,
h2,
h3 {
  margin-bottom: 0.5em;
}

.file-input {
  display: none;
}

.file-upload-label {
  display: inline-block;
  padding: 7px;
  color: white;
  font-size: 16px;
  text-decoration: none;
  width: -moz-fit-content;
  width: fit-content;
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 8px;
  cursor: pointer;
}
.file-upload-label:hover {
  transition: 0.5s;
  background-color: #ffffff;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 8px;
}
.file-upload-label:disabled {
  background-color: #ccc;
  color: #666;
  cursor: not-allowed;
}

.form-container {
  width: 50%;
  background-color: #ffffff;
  margin: 50px auto;
  padding: 20px 10px;
  border-radius: 16px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.9);
}
@media (max-width: 768px) {
  .form-container {
    width: 94%;
  }
}

button {
  display: inline-block;
  padding: 10px 20px;
  text-decoration: none;
  font-size: 16px;
  margin: 5px;
  width: -moz-fit-content;
  width: fit-content;
  color: #fff;
  background-color: var(--primary-color);
  border: 2px solid var(--primary-color);
  border-radius: 200px;
  cursor: pointer;
}
button:hover {
  transition: 0.5s;
  background-color: #ffffff;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
}
button:disabled {
  background-color: #ccc;
  color: #666;
  cursor: not-allowed;
}

.block {
  margin-bottom: 20px;
}

ul,
ol {
  list-style: none;
}

.options-list {
  list-style: none;
  max-height: 300px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  width: 100%;
  position: absolute;
  z-index: 1000;
  /* Установите достаточно высокий z-индекс */
}
.options-list.has-border {
  border-radius: 8px;
  background-color: #fbfbfb;
  border: 1px solid #ccc;
}
.options-list-item {
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.options-list-item:hover {
  border-radius: 8px;
  background-color: #f1f1f1;
}

.selected-option {
  margin-top: 10px;
  font-weight: bold;
}

img {
  max-width: 100%;
  height: auto;
}

.input-auto-height {
  flex: 1 1;
  padding: 5px;
  background-color: #ffffff;
  resize: none;
  align-content: center;
  border: 1px solid var(--secondary-color);
  max-height: 200px;
  /* Максимальная высота */
  height: auto;
  /* Автоматическая высота в зависимости от контента */
  outline: none;
  overflow-y: auto;
  /* Добавим скролл, если контент превышает максимальную высоту */
  /* Убираем стандартное выделение у textarea */
}
.input-auto-height:focus-within {
  border-color: none;
  /* Цвет выделения */
  box-shadow: none;
  /* Тень вокруг контейнера */
}

input,
textarea {
  width: 100%;
  font-size: 16px;
  border-radius: 8px;
  font-family: Arial, sans-serif;
  height: 45px;
  border: 1px solid var(--secondary-color);
  padding: 10px;
}
input:focus,
textarea:focus {
  border: 1px solid var(--secondary-color);
  box-shadow: 0 0 5px var(--secondary-color);
  outline: none;
}

.headerTitle {
  text-align: center;
  font-size: 44px;
  margin-top: 15px;
}
@media (max-width: 768px) {
  .headerTitle {
    font-size: 20px;
  }
}

.headerMiniTitle {
  width: 50%;
  margin: 50px auto;
  text-align: justify;
  margin-top: 15px;
}
@media (max-width: 768px) {
  .headerMiniTitle {
    width: 80%;
    font-size: 16px;
  }
}

.headerContanier {
  margin: 10px;
  font-size: 20px;
  font-weight: bold;
}

.сontanierText {
  margin: 10px;
  text-align: justify;
  font-size: 18px;
}

.modal {
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  z-index: 2000;
  transition: opacity 0.3s;
}
.modal.active {
  opacity: 1;
  pointer-events: all;
}
.modal .modal_contanier {
  position: relative;
  max-height: 95vh;
  min-width: 500px;
  transform: scale(0.5);
  transition: transform 0.4s, opacity 0.4s;
  will-change: transform, opacity;
  align-items: center;
  justify-content: center;
}
.modal .modal_contanier.active {
  transform: scale(1);
}
@media (max-width: 768px) {
  .modal .modal_contanier {
    min-width: 50px;
    max-height: 100vh;
    max-width: 400px;
    /* Исправьте значение для мобильных устройств */
  }
}
.modal .modal_contanier .modal__content {
  max-height: 95vh;
  position: relative;
  /* Максимальная высота модалки */
  overflow: auto;
  /* Прокрутка при переполнении */
  padding: 20px;
  border-radius: 12px;
  background-color: white;
}
.modal .modal_contanier .modal__content::-webkit-scrollbar {
  width: 8px;
}
.modal .modal_contanier .modal__content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.modal .modal_contanier .modal__content::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
}
.modal .modal_contanier .modal__content .view-container {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  color: #333;
  width: 120vh;
  height: 100%;
  padding: 0;
  margin: 0;
  border-radius: 0;
  box-shadow: none;
  overflow: auto;
}
.modal .modal_contanier .modal__content .view-container .icon-container {
  position: absolute;
  top: 27px;
  right: 60px;
}
.modal .modal_contanier .modal__content .view-container .icon-container .tooltip-text {
  visibility: hidden;
  background-color: rgba(40, 40, 40, 0.9); /* Более темный фон */
  color: #fff;
  overflow: auto;
  max-height: 700px;
  text-align: left; /* Прижимает текст к левому краю */
  border-radius: 8px; /* Увеличенный радиус скругления */
  padding: 10px 15px; /* Более крупные отступы для удобства */
  position: absolute;
  z-index: 1;
  right: 0;
  line-height: 1.6;
  top: 30px;
  width: 600px; /* Автоширина для текста */
  word-wrap: break-word; /* Перенос длинных слов */
  white-space: pre-line; /* Обработка \\n для новой строки */
  opacity: 0;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  /* Эффекты для красоты */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Тень для объема */
  border: 1px solid rgba(255, 255, 255, 0.2); /* Легкая граница */
}
.modal .modal_contanier .modal__content .view-container .icon-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.modal .modal_contanier .modal__content .view-container .file-contanier {
  position: relative;
}
.modal .modal_contanier .modal__content .view-container .file-contanier strong {
  cursor: pointer;
  /* Меняет курсор на указатель */
  transition: color 0.3s ease;
  /* Плавный переход цвета */
  position: relative;
  /* Для позиционирования стрелочки */
}
.modal .modal_contanier .modal__content .view-container .file-contanier strong::after {
  content: "▼";
  /* Стрелочка вниз */
  display: inline-block;
  margin-left: 8px;
  /* Отступ между текстом и стрелочкой */
  font-size: 12px;
  /* Размер стрелочки */
  transition: transform 0.3s ease;
  /* Плавный переход стрелочки */
}
.modal .modal_contanier .modal__content .view-container .file-contanier strong.active::after {
  transform: rotate(180deg);
  /* Поворачивает стрелочку при открытом состоянии */
}
.modal .modal_contanier .modal__content .view-container .file-contanier strong:hover {
  color: #0056b3;
  /* Изменение цвета при наведении */
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend {
  display: none;
  position: relative;
  left: 0;
  width: 30vw;
  padding: 16px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 100;
  transition: opacity 0.3s ease;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend.active {
  display: flex;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-images {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-images .image-container {
  text-align: center;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-images .image-container .file-image {
  width: 100%;
  height: auto;
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.3s ease, opacity 0.3s ease;
  will-change: transform, opacity;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-images .image-container .file-image:hover {
  transform: scale(1.05);
  opacity: 0.9;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-icons {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-icons .file-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-icons .file-item:hover {
  transform: scale(1.05);
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-icons .file-item .file-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
.modal .modal_contanier .modal__content .view-container .file-contanier .file-legend .file-icons .file-item .file-name {
  margin: 0;
  font-size: 14px;
  color: #555;
  max-width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.modal .modal_contanier .modal__content .view-container .details {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.modal .modal_contanier .modal__content .view-container .details .column {
  flex: 0 0 48%;
  margin: 0;
}
.modal .modal_contanier .modal__content .view-container .details .content {
  margin: 0;
  display: flex;
  width: 30vw;
}
.modal .modal_contanier .modal__content .view-container .details .content .text-container {
  overflow: hidden;
  white-space: nowrap;
  margin-left: auto;
  width: 100%;
  text-overflow: ellipsis;
}
.modal .modal_contanier .modal__content .view-container .details .content .text-container:hover .full-text {
  display: block;
}
.modal .modal_contanier .modal__content .view-container .details .content .full-text {
  display: none;
  position: absolute;
  border-radius: 8px;
  white-space: normal;
  font-size: 18px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 4000;
  max-width: 500px;
}
.modal .modal_contanier .modal__content .view-container .chat-container {
  height: 450px;
}
.modal .modal_contanier .modal__content .view-container h2 {
  color: var(--primary-color);
  margin-bottom: 5px;
}
.modal .modal_contanier .modal__content .view-container .additional-content {
  padding: 10px;
  border-top: 1px solid #ccc;
  margin-top: 20px;
}
.modal .modal_contanier .modal__content .view-container .additional-content > p {
  color: black;
}
.modal .modal_contanier .modal__content .view-container .details-actions-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
}
.modal .modal__close {
  transform: scale(0.5);
  cursor: pointer;
  position: absolute;
  top: 10px;
  /* Положение кнопки закрытия */
  right: 10px;
  padding: 5px;
  border-radius: 200px;
  /* Положение кнопки закрытия */
  z-index: 100;
  transition: transform 0.3s;
}
.modal .modal__close:hover {
  transform: scale(0.6);
}
@media (max-width: 768px) {
  .modal {
    /* Исправьте значение для мобильных устройств */
  }
}

.custom-navbar {
  background-color: rgb(255, 255, 255);
  margin-left: 1px;
}

.nav-link {
  color: var(--primary-color);
  border-radius: 8px;
}
.nav-link:hover {
  border-radius: 8px;
  color: #ffffff;
  background-color: var(--primary-color);
}

.button-func {
  margin: 5px;
  background-color: var(--primary-color);
  color: rgb(255, 255, 255);
  border: 2px solid var(--primary-color);
  width: 100px;
  height: 40px;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}
.button-func:hover {
  background-color: rgb(255, 255, 255);
  color: var(--primary-color);
  border-radius: 8px;
  border: 2px solid var(--primary-color);
}

.logo {
  width: 40px;
  height: 40px;
  margin: 10px;
}

.logo-neon {
  display: inline-block;
  position: relative;
  padding: 3px;
  width: 40px;
  overflow: visible;
  height: 40px;
}
.logo-neon .path {
  fill: none;
  stroke-width: 0.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke: #b6e33e;
  filter: drop-shadow(0 0 5px rgba(182, 227, 62, 0.5)) drop-shadow(0 0 10px rgba(182, 227, 62, 0.5));
  transition: filter 0.3s ease-in-out;
  animation: neon-glow 1.5s ease-in-out infinite, blink 7s linear infinite;
}
.logo-neon .path:nth-child(1) {
  stroke: #b6e33e;
  animation: neon-glow 1.5s ease-in-out infinite, blink-general 8s linear infinite;
}
.logo-neon .path:nth-child(2) {
  stroke: #b6e33e;
  animation: neon-glow 2s ease-in-out infinite, blink-general 9s linear infinite;
}
.logo-neon .path:nth-child(3) {
  stroke: #b6e33e;
  animation: neon-glow 1.8s ease-in-out infinite, blink-general 7s linear infinite;
}
.logo-neon .path:nth-child(4) {
  stroke: #b6e33e;
  animation: neon-glow 1.6s ease-in-out infinite, blink-general 6s linear infinite;
}
.logo-neon .path:last-child {
  stroke: rgb(77, 128, 0);
  animation: neon-glow-alt 2s ease-in-out infinite, blink-last 7.5s linear infinite;
}

@keyframes neon-glow {
  0%, 100% {
    filter: drop-shadow(0 0 1px rgba(182, 227, 62, 0.3)) drop-shadow(0 0 2px rgba(182, 227, 62, 0.3));
  }
  25% {
    filter: drop-shadow(0 0 1px rgba(182, 227, 62, 0.5)) drop-shadow(0 0 2px rgba(182, 227, 62, 0.5));
  }
  50% {
    filter: drop-shadow(0 0 1px rgba(182, 227, 62, 0.7)) drop-shadow(0 0 2px rgba(182, 227, 62, 0.7));
  }
  75% {
    filter: drop-shadow(0 0 1px rgba(182, 227, 62, 0.4)) drop-shadow(0 0 2px rgba(182, 227, 62, 0.4));
  }
}
@keyframes neon-glow-alt {
  0%, 100% {
    filter: drop-shadow(0 0 1px rgba(92, 255, 51, 0.3)) drop-shadow(0 0 2px rgba(92, 255, 51, 0.3));
  }
  25% {
    filter: drop-shadow(0 0 1px rgba(92, 255, 51, 0.5)) drop-shadow(0 0 2px rgba(92, 255, 51, 0.5));
  }
  50% {
    filter: drop-shadow(0 0 1px rgba(92, 255, 51, 0.7)) drop-shadow(0 0 2px rgba(92, 255, 51, 0.7));
  }
  75% {
    filter: drop-shadow(0 0 1px rgba(92, 255, 51, 0.4)) drop-shadow(0 0 2px rgba(92, 255, 51, 0.4));
  }
}
@keyframes blink-general {
  0%, 93%, 100% {
    stroke: #b6e33e;
  }
  99% {
    stroke: #546621;
  }
  98% {
    stroke: #b6e33e;
  }
  97% {
    stroke: #708b26;
  }
  96% {
    stroke: #b6e33e;
  }
  95% {
    stroke: #546621;
  }
  94% {
    stroke: #b6e33e;
  }
}
@keyframes blink-last {
  0%, 93%, 100% {
    stroke: rgb(77, 128, 0);
  }
  99% {
    stroke: rgb(38, 63, 0);
  }
  98% {
    stroke: rgb(77, 128, 0);
  }
  97% {
    stroke: rgb(38, 63, 0);
  }
  96% {
    stroke: rgb(77, 128, 0);
  }
  95% {
    stroke: rgb(38, 63, 0);
  }
  94% {
    stroke: rgb(77, 128, 0);
  }
}
.date-picker-container {
  display: flex;
  align-items: center;
  justify-content: start;
}

.date-picker-label {
  margin-right: 10px;
  /* Отступ справа от метки */
}

.toggle-button {
  display: none;
}

@media (max-width: 768px) {
  .toggle-button {
    display: flex;
    background-color: white;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    /* Отключение выделения текста при клике */
    display: flex;
    align-items: center;
  }
  .arrow {
    display: inline-block;
    margin-left: 8px;
    transition: transform 0.3s ease;
    /* Анимация вращения */
  }
  .arrow.open {
    transform: rotate(180deg);
    /* Вращение на 180 градусов */
  }
  .checkbox-container {
    margin: 10px;
  }
  .date-picker-container {
    display: contents;
    background-color: white;
    z-index: 1000;
    /* На мобильных устройствах контейнеры занимают всю ширину */
  }
  .date-picker-container .date-picker-label {
    margin: 10px;
  }
  .date-picker-container .input {
    margin: 10px;
  }
  .date-picker-container {
    display: none;
    flex-direction: column;
    align-items: flex-start;
  }
  .date-picker-container.open {
    display: flex;
  }
}
.checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 16px;
  color: #333;
  position: relative;
}
.checkbox-container .checkbox-input {
  opacity: 0;
  position: absolute;
  cursor: pointer;
  z-index: 1;
}
.checkbox-container .checkbox-input:disabled {
  cursor: not-allowed;
}
.checkbox-container .checkmark {
  width: 24px;
  height: 24px;
  border: 1px solid #ccc;
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  margin-right: 12px;
}
.checkbox-container .checkmark::after {
  content: "";
  position: absolute;
  display: none;
  width: 8px;
  height: 16px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
}
.checkbox-container .checkbox-input:checked + .checkmark {
  background-color: #007bff;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}
.checkbox-container .checkbox-input:checked + .checkmark::after {
  display: block;
}
.checkbox-container:hover .checkmark {
  background-color: #e6e6e6;
  border-color: #999;
}
.checkbox-container .checkbox-input:disabled + .checkmark {
  background-color: #f2f2f2;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.checkbox-container .checkbox-label {
  font-size: 16px;
  color: #333;
}
.checkbox-input:disabled + .checkmark + .checkbox-container .checkbox-label {
  color: #b3b3b3;
  cursor: not-allowed;
}

.chat-container {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
}
.chat-container .chat {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.chat-container .chat h4 {
  font-size: 22px;
  margin-bottom: 15px;
  margin: 10px;
  color: #333;
  font-weight: 600;
}
.chat-container .chat .message {
  border-radius: 10px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  margin: 10px 0;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  background-color: #fff;
  position: relative;
  transition: background-color 0.3s ease, transform 0.3s ease;
  will-change: background-color, transform;
  word-break: break-word;
  overflow-wrap: break-word;
}
.chat-container .chat .message.highlighted {
  background-color: rgba(255, 0, 0, 0.1);
  animation: chatpulse 3s infinite;
}
@keyframes chatpulse {
  0% {
    background-color: rgba(160, 0, 0, 0.1);
  }
  50% {
    background-color: rgba(255, 0, 0, 0.2);
  }
  90% {
    background-color: rgba(255, 0, 0, 0.1);
  }
}
.chat-container .chat .message .chat-avatar {
  width: 50px;
  height: 50px;
  margin-right: 12px;
  border-radius: 50%;
  object-fit: cover;
}
.chat-container .chat .message .chat-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.chat-container .chat .message .chat-content span {
  margin: 0;
  font-size: 18px;
  color: #444;
}
.chat-container .chat .message .chat-content strong {
  margin: 0;
  font-size: 18px;
  color: #000;
}
.chat-container .chat .message .chat-content .message-date,
.chat-container .chat .message .chat-content .message-category {
  margin-left: auto;
  color: #999;
  font-size: 14px;
}
.chat-container .chat .message .chat-content .file-images {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.chat-container .chat .message .chat-content .file-images .image-container {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 12px);
  max-width: calc(33% - 12px);
  text-align: center;
}
.chat-container .chat .message .chat-content .file-images .image-container .file-image {
  width: 100%;
  height: auto;
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.3s ease, opacity 0.3s ease;
  will-change: transform, opacity;
}
.chat-container .chat .message .chat-content .file-images .image-container .file-image:hover {
  transform: scale(1.05);
  opacity: 0.9;
}
.chat-container .chat .message .chat-content .file-icons {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.chat-container .chat .message .chat-content .file-icons .file-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  transition: transform 0.3s ease;
}
.chat-container .chat .message .chat-content .file-icons .file-item:hover {
  transform: scale(1.05);
}
.chat-container .chat .message .chat-content .file-icons .file-item .file-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
.chat-container .chat .message .chat-content .file-icons .file-item .file-name {
  margin: 0;
  font-size: 14px;
  color: #555;
  max-width: calc(100% - 40px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.chat-container .edit-icon {
  margin-left: auto;
  color: #888;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.3s ease;
}
.chat-container .edit-icon:hover {
  color: #333;
  transform: scale(1.1);
}
.chat-container .comment-input {
  padding: 10px;
  margin-top: auto;
}

/* Медиазапросы для мобильных устройств */
@media (max-width: 768px) {
  .chat-content {
    width: 85% !important;
  }
  .chat-avatar {
    width: 40px !important;
    height: 40px !important;
  }
}
.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  gap: 10px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.header {
  padding: 5px;
  height: 28px;
  background-color: var(--primary-color);
  color: white;
  align-items: center;
  display: flex;
  border-radius: 8px;
}
.header p {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

@media (max-width: 768px) {
  body {
    font-size: 14px;
  }
  .grid-view-container {
    display: block;
  }
  .grid-view-container .grid-container,
  .grid-view-container .view-container {
    width: 100%;
  }
  .button-func,
  button {
    width: auto;
    padding: 8px 16px;
  }
  .modal__content {
    min-width: 300px;
    transform: scale(1);
  }
  .search-container {
    flex-direction: column;
    align-items: stretch;
  }
}
.container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(600px, 1fr));
  /* Создаем грид с колонками шириной 300px (минимум) и автоматически расширяемыми */
  grid-gap: 20px;
  /* Отступ между элементами */
  justify-content: center;
  /* Центрируем контейнеры по горизонтали */
}

.tracking-container {
  height: 85vh;
  overflow: auto;
  margin: 10px 20px;
  padding: 0px 10px;
  box-sizing: border-box;
  background-color: rgb(255, 255, 255);
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

@media (max-width: 768px) {
  .container {
    grid-template-columns: 1fr;
    /* На мобильных устройствах контейнеры занимают всю ширину */
  }
}
.notification-icon-container {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1299;
}
.notification-icon-container .notification-icon {
  cursor: pointer;
  position: relative;
  z-index: 2;
  /* Счетчик для персональных уведомлений (слева от иконки) */
  /* Счетчик для системных уведомлений (справа от иконки) */
}
.notification-icon-container .notification-icon .icon {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s;
}
.notification-icon-container .notification-icon .icon svg {
  fill: white;
}
.notification-icon-container .notification-icon .icon.blink {
  animation: blinkAnimation 1s infinite;
}
@keyframes blinkAnimation {
  0% {
    box-shadow: 0 0 0px var(--secondary-color);
  }
  50% {
    box-shadow: 0 0 20px var(--secondary-color);
  }
  100% {
    box-shadow: 0 0 0px var(--secondary-color);
  }
}
.notification-icon-container .notification-icon .personal-count {
  background-color: var(--primary-color);
  color: white;
  font-weight: bold;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: -8px;
  left: -8px;
  /* Слева от иконки */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}
.notification-icon-container .notification-icon .system-count {
  background-color: #ff6347;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: -8px;
  right: -8px;
  /* Справа от иконки */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}
.notification-icon-container .notification-icon:hover .icon svg {
  transform: scale(1.1);
}
.notification-icon-container .notification-list {
  position: fixed;
  top: 0px;
  right: -100%;
  width: 30%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
  padding: 20px;
  overflow-y: auto;
  transition: right 0.3s;
}
.notification-icon-container .notification-list.open {
  right: 0;
}
.notification-icon-container .notification-list .notification-tabs {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}
.notification-icon-container .notification-list .notification-tabs button {
  flex-grow: 1;
  padding: 12px 20px;
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.notification-icon-container .notification-list .notification-tabs button.active {
  background-color: rgba(255, 255, 255, 0.6);
  color: var(--primary-color);
}
.notification-icon-container .notification-list .notification-tabs button:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
.notification-icon-container .notification-list .notification-tabs button:focus {
  outline: none;
}
.notification-icon-container .notification-list ul {
  list-style: none;
  padding: 0;
}
.notification-icon-container .notification-list ul .notification-item {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  margin-bottom: 15px;
  cursor: pointer;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
}
.notification-icon-container .notification-list ul .notification-item:hover {
  transform: translateY(-5px);
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.3);
}
.notification-icon-container .notification-list ul .notification-item.unread {
  font-weight: bold;
  background-color: rgba(255, 243, 205, 0.9);
}
.notification-icon-container .notification-list ul .notification-item .notification-content {
  display: grid;
  grid-template-areas: "header header header" "message delete delete";
  grid-template-columns: 1fr auto;
  gap: 5px;
  border-radius: 12px;
  margin-bottom: 15px;
  padding: 15px;
  cursor: pointer;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
}
.notification-icon-container .notification-list ul .notification-item .notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-area: header;
}
.notification-icon-container .notification-list ul .notification-item .task-id {
  font-weight: bold;
  color: #110092;
  font-size: 16px;
  text-decoration: underline;
}
.notification-icon-container .notification-list ul .notification-item .notification-date {
  color: rgba(0, 0, 0, 0.3529411765);
  font-size: 12px;
  font-weight: bold;
}
.notification-icon-container .notification-list ul .notification-item .message {
  grid-area: message;
  width: 100%;
  overflow-wrap: break-word;
  color: #333;
  font-size: 16px;
}
.notification-icon-container .notification-list ul .notification-item .delete-button {
  grid-area: delete;
  background: none;
  border: none;
  width: 40px;
  height: 40px;
  color: #630000;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  transition: color 0.3s;
  align-self: center;
  /* Center vertically in its grid cell */
}
.notification-icon-container .notification-list ul .notification-item .delete-button:hover {
  color: #ff0000;
}
@media (max-width: 480px) {
  .notification-icon-container {
    right: 10px;
    bottom: 10px;
  }
  .notification-icon-container .notification-icon .icon {
    width: 35px;
    height: 35px;
  }
  .notification-icon-container .personal-count,
  .notification-icon-container .system-count {
    width: 20px;
    height: 20px;
    font-size: 12px;
  }
  .notification-icon-container .notification-list {
    width: 100%;
    padding: 10px;
  }
  .notification-icon-container .notification-list .notification-tabs button {
    padding: 8px;
    font-size: 14px;
  }
  .notification-icon-container .notification-list ul .notification-item {
    font-size: 12px;
  }
  .notification-icon-container .notification-list .notification-content .message {
    font-size: 12px;
  }
  .notification-icon-container .notification-list .delete-button {
    font-size: 18px;
  }
}

.notification {
  position: fixed;
  top: 0px;
  right: 20px;
  padding: 15px;
  background: #ffffff;
  opacity: 0;
  font-weight: bold;
  transform: translateY(0);
  transition: opacity 0.3s, transform 0.3s;
  z-index: 1100;
  border-radius: 8px;
  font-family: Arial, sans-serif;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  border: 1px solid #000000;
  /* Красная рамка */
  overflow: hidden;
}
.notification.success {
  color: #4caf50;
  /* Зеленый цвет для успешных уведомлений */
  border-color: #4caf50;
  /* Зеленая рамка */
}
.notification.success::after {
  background-color: #4caf50;
  /* Красная полоска */
}
.notification.error {
  color: #f44336;
  /* Красный цвет для уведомлений об ошибках */
  border-color: #f44336;
  /* Красная рамка */
}
.notification.error::after {
  background-color: #f44336;
  /* Красная полоска */
}
.notification.animate-in-out {
  animation: fadeInOut 2s ease-in-out;
}
.notification::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background-color: rgba(0, 0, 0, 0.1);
  /* Полоска снизу */
  animation: slideOut 2s linear;
}

@keyframes fadeInOut {
  0%, 100% {
    opacity: 0;
    transform: translateY(0);
  }
  20%, 80% {
    opacity: 1;
    transform: translateY(50%);
  }
}
@keyframes slideOut {
  0% {
    width: 100%;
  }
  100% {
    width: 0;
  }
}
.user-container-info {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.user-info {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  margin: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 48%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.user-info h2 {
  font-size: 20px;
  margin-bottom: 10px;
}
.user-info ul {
  list-style: none;
  padding: 0;
}
.user-info ul li {
  margin-bottom: 5px;
}
.user-info ul li strong {
  margin-right: 5px;
}

.avatar {
  position: relative;
  width: 100px;
  height: 100px;
  margin: auto 20px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
.avatar .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avatar:hover .avatar-hover {
  display: flex;
}

.avatar-hover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  border-radius: 50%;
}
.avatar-hover label {
  cursor: pointer;
}

.custom-file-upload {
  cursor: pointer;
  text-align: center;
}

#file-upload {
  display: none;
}

@media (max-width: 768px) {
  .user-info {
    width: 100%;
    margin: 10px 0;
  }
}
.depart-workload {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
}
.depart-workload .dropdown {
  position: relative;
  display: inline-block;
}
.depart-workload .dropdown .dropdown-button {
  background-color: white;
  color: var(--primary-color);
  padding: 5px;
  height: 30px;
  border: 1px solid var(--primary-color);
  cursor: pointer;
  font-size: 1rem;
  border-radius: 8px;
  position: relative;
  white-space: nowrap;
  transition: background-color 0.3s, color 0.3s;
  display: flex;
  align-items: center;
}
.depart-workload .dropdown .dropdown-button .button-text {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.depart-workload .dropdown .dropdown-button.selected {
  background-color: var(--primary-color);
  color: #fff;
}
.depart-workload .dropdown .dropdown-button.selected .clear-selection {
  cursor: pointer;
  font-size: 1rem;
  margin-left: 5px;
  color: #fff;
}
.depart-workload .dropdown .dropdown-button.selected .clear-selection:hover {
  color: var(--primary-color);
  border-radius: 8px;
  background-color: #fff;
}
.depart-workload .dropdown .dropdown-button .clear-selection {
  margin-left: auto;
  cursor: pointer;
  font-size: 1rem;
  color: var(--primary-color);
}
.depart-workload .dropdown .dropdown-button .clear-selection:hover {
  color: var(--secondary-color);
}
.depart-workload .dropdown .dropdown-content {
  display: block;
  position: absolute;
  background-color: #f9f9f9;
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  padding: 5px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 3;
  width: auto;
  min-width: 150px;
  margin-top: 0.5rem;
  left: 0;
}
.depart-workload .dropdown .dropdown-content .item {
  border-bottom: 1px solid #ddd;
  border-radius: 8px;
  padding: 5px;
}
.depart-workload .dropdown .dropdown-content .item:last-child {
  border-bottom: none;
}
.depart-workload .dropdown .dropdown-content .item .item-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.depart-workload .dropdown .dropdown-content .item.selected {
  background-color: var(--primary-color);
  color: white;
}

.year-month-selector {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}
.year-month-selector__select {
  padding: 5px;
  font-size: 16px;
  height: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
  cursor: pointer;
}
.year-month-selector__select:hover {
  border-color: #888;
}
.year-month-selector__select:focus {
  outline: none;
  border-color: #555;
}

.link-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Arial, sans-serif;
  padding: 20px;
  background-color: var(--background-color);
  width: 98%;
  border-radius: 16px;
  box-sizing: border-box;
  margin: 10px;
  height: 80vh;
}
.link-container h1 {
  color: #333;
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 15px;
  background-color: #fff;
}
.link-container .link-content {
  display: flex;
  width: 100%;
  height: 100%;
  gap: 20px;
}
.link-container .link-block {
  display: flex;
  flex: 1 1;
  gap: 20px;
  height: 85%;
  width: 100%;
  /* Ширина блока в 100%, чтобы контролировать ширину колонок */
  /* Медиазапрос для мобильных устройств */
  /* Ширина колонок для ПК */
}
.link-container .link-block .project-def {
  padding: 10px;
  background-color: var(--primary-color);
  border-radius: 15px;
  transition: background-color 0.2s ease;
  overflow-y: auto;
  /* Прокрутка для списка сотрудников */
  max-height: 100%;
  /* Ограничение высоты блока */
  width: 100%;
  /* Занимает всю доступную ширину в .link-block */
}
.link-container .link-block .project-def h2,
.link-container .link-block .project-def h3 {
  border-radius: 5px;
  color: #333;
  font-size: 16px;
  margin-bottom: 10px;
  text-align: center;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  padding: 10px 0;
  z-index: 1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.link-container .link-block .project-wrapper {
  display: flex;
  flex-direction: row;
  /* Колонки будут располагаться горизонтально */
  flex: 1 1;
  gap: 20px;
  overflow-x: auto;
  /* Горизонтальная прокрутка для блоков проектов */
  padding-bottom: 10px;
  /* Чтобы блоки .project масштабировались автоматически */
}
.link-container .link-block .project-wrapper .project {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 15px;
  padding: 10px;
  box-shadow: 0 2px 5px rgba(16, 112, 50, 0.3);
  overflow-y: auto;
  /* Вертикальная прокрутка внутри блока проекта */
  overflow-x: hidden;
  /* Убираем горизонтальную прокрутку */
  flex: 1 0 250px;
  /* Гибкая ширина блока проекта */
  max-height: 100%;
}
.link-container .link-block .project-wrapper .project h3 {
  color: #333;
  font-size: 16px;
  margin-bottom: 10px;
  border-radius: 5px;
  text-align: center;
  position: sticky;
  top: 0;
  background-color: #ffffff;
  padding: 10px 0;
  z-index: 1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.link-container .link-block .project-wrapper .project .category-new {
  background-color: #f9f9f9;
  color: #333;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.link-container .link-block .project-wrapper .project .category-new button {
  background: none;
  border: none;
  color: #d9534f;
  font-size: 16px;
  cursor: pointer;
  transition: color 0.2s ease;
}
.link-container .link-block .project-wrapper .project .category-new button:hover {
  color: #c9302c;
}
@media (max-width: 600px) {
  .link-container .link-block .project-def,
  .link-container .link-block .project-wrapper {
    width: 40%;
    /* Ширина колонок на мобильных устройствах */
  }
}
@media (min-width: 601px) {
  .link-container .link-block .project-def,
  .link-container .link-block .project-wrapper {
    width: 20%;
    /* Ширина колонок на ПК */
  }
}
.link-container .category,
.link-container .category-new {
  padding: 10px;
  margin: 5px 0;
  background-color: #ffffff;
  border-radius: 5px;
  cursor: grab;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  font-size: 14px;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
}
.link-container .category:hover,
.link-container .category-new:hover {
  transform: scale(1.05);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
}

.dragged-element {
  display: none;
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 1000;
  transform: translate(-50%, -50%);
}

/* Медиазапрос для мобильных устройств */
@media (max-width: 600px) {
  .dragged-element {
    position: absolute;
    display: flex;
    padding: 8px;
    font-size: 16px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.95);
  }
}
.accordion {
  margin: 20px;
}
.accordion .accordion-panel {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.accordion .accordion-panel .accordion-header {
  cursor: pointer;
  padding: 15px 20px;
  background-color: #fafafa;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.3s ease;
}
.accordion .accordion-panel .accordion-header.active {
  background-color: #e0e0e0;
}
.accordion .accordion-panel .accordion-header .header-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.accordion .accordion-panel .accordion-header .header-content .colum {
  flex: 1 1;
  margin: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 18px;
  text-overflow: ellipsis;
}
.accordion .accordion-panel .accordion-header .chevron {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
}
.accordion .accordion-panel .accordion-header .chevron.rotate {
  transform: rotate(180deg);
}
.accordion .accordion-panel .accordion-content {
  padding: 15px 20px;
  background-color: #fff;
}
.accordion .accordion-panel .accordion-content ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.accordion .accordion-panel .accordion-content ul li {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  transition: background-color 0.3s ease;
  justify-content: space-between;
}
.accordion .accordion-panel .accordion-content ul li:last-child {
  border-bottom: none;
}
.accordion .accordion-panel .accordion-content ul li:hover {
  background-color: #f9f9f9;
}
.accordion .accordion-panel .accordion-content ul li span {
  margin: 0 10px;
  color: #666;
  font-size: 16px;
}
.accordion .accordion-panel .accordion-content ul li a {
  text-decoration: none;
  color: #007bff;
  font-weight: 500;
  margin-right: 10px;
  transition: color 0.3s ease;
}
.accordion .accordion-panel .accordion-content ul li a:hover {
  color: #0056b3;
}

.attendance {
  padding: 10px;
  margin: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: auto;
}
.attendance .table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.attendance .table th,
.attendance .table td {
  padding: 7px 2px;
  text-align: center;
  font-size: 14px;
  border: 1px solid #e0e0e0;
}
.attendance .table th.weekend,
.attendance .table td.weekend {
  background-color: #fcbbbb;
  color: #710c0c;
}
.attendance .table th select,
.attendance .table td select {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.attendance .table th select:focus,
.attendance .table td select:focus {
  outline: none;
  border-color: #007bff;
}
.attendance .table thead {
  background-color: var(--primary-color);
  color: #fff;
  font-weight: bold;
}
.attendance .table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}
.attendance .table tbody tr:hover {
  background-color: #e0e0e0;
}
.attendance .table tbody tr td:first-child {
  text-align: left;
  font-weight: bold;
  white-space: nowrap;
}
.attendance .table tbody tr td .input {
  height: auto;
  width: 40px;
  padding: 2px;
  border: 0;
}
.attendance .table tbody tr td .input.status-vacation {
  background-color: yellow;
}
.attendance .table tbody tr td .input.status-sick {
  background-color: red;
}
.attendance .table tbody tr td .input.status-business-trip {
  background-color: blue;
}
.attendance .table tbody tr td .input.status-off {
  background-color: grey;
}
.attendance .table tbody tr td .input.status-present {
  background-color: green;
}
.attendance .table tbody tr td.weekend {
  background-color: #ffebee;
  color: #d32f2f;
}

.legend {
  background-color: #fff;
  border-radius: 8px;
  width: auto;
  margin: 10px;
  display: inline-block;
}

.legend p {
  padding: 5px;
}

.legend span {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  text-align: center;
  color: white;
  font-weight: bold;
}
.legend span.status-vacation {
  background-color: yellow;
}
.legend span.status-sick {
  background-color: red;
}
.legend span.status-business-trip {
  background-color: blue;
}
.legend span.status-off {
  background-color: grey;
}
.legend span.status-present {
  background-color: green;
}

.vacation-schedule {
  margin: 10px;
  border-radius: 8px;
  padding: 10px;
  background-color: #ffffff;
}
.vacation-schedule h2 {
  text-align: center;
  margin-bottom: 20px;
}
.vacation-schedule table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.vacation-schedule table th,
.vacation-schedule table td {
  border: 1px solid #ddd;
  padding: 8px;
  background-color: #f0f0f0;
  text-align: center;
}
.vacation-schedule table th {
  background-color: #f2f2f2;
}

.year-selector {
  display: flex;
  gap: 10px;
  padding: 5px;
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 20px;
}
.year-selector .p {
  align-content: center;
}
.year-selector .year {
  padding: 5px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
  cursor: pointer;
}
.year-selector .year:hover {
  border-color: #888;
}
.year-selector .year:focus {
  outline: none;
  border-color: #555;
}

.service-category p {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0.8em;
  color: #333;
  /* Темный цвет для заголовка */
}
.service-category .service-category-header {
  display: grid;
  grid-template-columns: 1fr 100px 100px 50px;
  /* Перераспределение ширины */
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
  margin-bottom: 15px;
}
.service-category .service-category-header .service-category-header-item {
  font-weight: 600;
  color: #555;
  /* Мягкий серый цвет для заголовков */
  font-size: 14px;
}
.service-category .service-category-item {
  display: grid;
  grid-template-columns: 1fr 100px 100px 50px;
  /* Перераспределение ширины */
  gap: 10px;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.service-category .service-category-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.service-category .service-category-item .service-category-content {
  display: flex;
  align-items: center;
  color: #444;
  /* Насыщенный серый для текста */
  font-size: 14px;
}
.service-category .service-category-item .service-category-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.service-category .service-category-item .service-category-buttons {
  display: flex;
  gap: 4px;
  /* Уменьшено расстояние между кнопками */
  justify-content: center;
  align-items: center;
  max-width: 50px;
  /* Максимальная ширина для контейнера */
}
.service-category .service-category-item .icon-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  padding: 2px;
  transition: color 0.2s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.service-category .service-category-item .icon-button:hover {
  color: #0056b3;
  transform: scale(1.1);
}
.service-category .service-category-item .delete-button i {
  color: #ff4d4d;
  /* Красный для удаления */
}
.service-category .service-category-item .add-service-button i {
  color: #007bff;
  /* Синий для добавления */
  font-size: 24px;
  /* Увеличенный размер иконки */
}

.clip-icon {
  cursor: pointer;
  margin: auto 10px 10px 10px;
  width: 24px;
  background-color: white;
  height: 24px;
  border-radius: 50px;
}
.clip-icon:hover {
  color: white;
  background-color: var(--primary-color);
  transition: 0.5s ease;
}

.enots {
  padding: 20px;
  margin: 20px;
  background-color: #f4f4f9;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  overflow: auto;
}
.enots .table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.enots .table th,
.enots .table td {
  padding: 8px 12px;
  text-align: center;
  font-size: 14px;
  border: 1px solid #e0e0e0;
}
.enots .table th input,
.enots .table td input {
  height: 20px;
  width: 40px;
  /* Уменьшенный размер для инпутов */
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}
.enots .table thead {
  background-color: var(--primary-color) !important;
  color: #ffffff;
  font-weight: bold;
}
.enots .table thead th {
  padding-right: 40px;
  padding: 5px;
  /* Добавлено место для иконок */
}
.enots .table thead th .head-name {
  display: flex;
}
.enots .table thead th .clip-icon {
  margin: 2px;
}
.enots .table .positive-column {
  background-color: #d4edda;
  /* Светло-зелёный фон */
}
.enots .table .negative-column {
  background-color: #edd4d4;
  /* Светло-зелёный фон */
}
.enots .table tbody tr:hover .positive-column {
  background-color: #9cff9c;
  /* Или другой цвет для negative-column при наведении */
}
.enots .table tbody tr:hover .negative-column {
  background-color: #ff9e9e;
  /* Или другой цвет для negative-column при наведении */
}
.enots .table tbody tr:nth-child(even) {
  background-color: #fafafa;
}
.enots .table tbody tr:hover {
  background-color: #f1f1f1 !important;
}
.enots .table tbody tr td {
  padding: 0px 10px;
}
.enots .table tbody tr td:first-child {
  text-align: left;
  font-weight: 600;
  white-space: nowrap;
}
.enots .table tbody tr td.weekend {
  background-color: #ffebee;
  color: #d32f2f;
}
.enots .checkbox-container {
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.enots .checkbox-container input[type=checkbox] {
  margin-right: 10px;
}
.enots .legend {
  padding: 15px;
  border-radius: 8px;
  background-color: #f8f9fa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}
.enots .legend h3 {
  margin-bottom: 10px;
  font-size: 1.5rem;
  color: #333;
  font-weight: bold;
}
.enots .legend ul {
  list-style-type: none;
  padding: 0;
}
.enots .legend ul li {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 1rem;
  color: #666;
}
.enots .legend ul li:last-child {
  border-bottom: none;
}
.enots .legend ul li.positive {
  color: #28a745;
}
.enots .legend ul li.negative {
  color: #dc3545;
}

.tracking-container {
  width: 95%;
  box-sizing: border-box;
}
.tracking-container .tracking-header {
  position: sticky;
  top: 0;
  padding: 15px;
  background-color: #ffffff;
  z-index: 100;
  font-size: 26px;
  font-weight: bold;
  color: #333;
  text-align: center;
  border-bottom: 2px solid #ddd;
  margin-bottom: 10px;
}
.tracking-container .tracking-wrapper {
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  position: relative;
}
.tracking-container .table {
  border-collapse: collapse;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  table-layout: fixed;
}
.tracking-container .table .fire-animation {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: left;
  background-repeat: no-repeat;
}
.tracking-container .table th {
  position: sticky;
  top: 0;
  background-color: #f2f2f2;
  padding: 12px 15px;
  text-align: center;
  font-weight: bold;
  color: #333;
  border-bottom: 2px solid #ddd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tracking-container .table .selected-column {
  background-color: var(--primary-color);
  color: #fff;
}
.tracking-container .table td {
  padding: 8px 15px;
  text-align: left;
  font-size: 16px;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.tracking-container .table td:first-child {
  padding-left: 20px;
  font-weight: bold;
}
.tracking-container .table td a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}
.tracking-container .table td a:hover {
  text-decoration: underline;
}
.tracking-container .table tr {
  transition: background-color 0.3s ease;
}
.tracking-container .table tr:nth-child(even) {
  background-color: #f9f9f9;
}
.tracking-container .table tr:hover {
  background-color: #e9ecef !important;
}
.tracking-container .table tr.highlight-red {
  background-color: rgba(255, 0, 0, 0.1) !important;
}
.tracking-container .table tr.selected {
  background-color: rgba(72, 255, 0, 0.1) !important;
}
.tracking-container .table-container {
  overflow-x: auto;
  max-height: 100%;
  position: relative;
}

.statistics-container {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.statistics-container h2 {
  margin-bottom: 20px;
  font-size: 1.5rem;
  color: #333;
}
.statistics-container .statistics-table-wrapper {
  max-height: 200px;
  /* Ограничиваем высоту контейнера */
  overflow-y: auto;
  border-radius: 20px;
  /* Вертикальная прокрутка */
}
.statistics-container .statistics-table-wrapper .statistics-table {
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
  /* Устанавливает фиксированное распределение ширины колонок */
  width: 100%;
  background-color: #ffffff;
}
.statistics-container .statistics-table-wrapper .statistics-table th {
  background-color: #ffffff;
  position: sticky;
  top: 0;
  padding: 14px;
  text-align: center;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  /* Необходимо для псевдоэлемента */
  z-index: 2;
  overflow: hidden;
}
.statistics-container .statistics-table-wrapper .statistics-table th::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  /* Ширина градиента */
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
  pointer-events: none;
  /* Не мешает взаимодействию с текстом */
}
.statistics-container .statistics-table-wrapper .statistics-table th .resizer-area {
  cursor: e-resize;
  position: absolute;
  right: 0;
  top: 10%;
  width: 2px;
  height: 80%;
  z-index: 1;
  transition: background-color 0.2s ease;
  background-color: rgba(0, 0, 0, 0.1);
}
.statistics-container .statistics-table-wrapper .statistics-table th .resizer-area:hover {
  background-color: rgba(0, 0, 0, 0.2);
}
.statistics-container .statistics-table-wrapper .statistics-table th.selected-column {
  background-color: var(--primary-color);
  color: #ffffff;
}
.statistics-container .statistics-table-wrapper .statistics-table th.selected-column::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  /* Ширина градиента */
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, var(--primary-color) 100%);
  pointer-events: none;
  /* Не мешает взаимодействию с текстом */
}
.statistics-container .statistics-table-wrapper .statistics-table tr {
  transition: background-color 0.3s ease;
}
.statistics-container .statistics-table-wrapper .statistics-table tr:nth-child(even) {
  background-color: #f9f9f9;
}
.statistics-container .statistics-table-wrapper .statistics-table tr:hover {
  background-color: #e9ecef !important;
}
.statistics-container .statistics-table-wrapper .statistics-table tr.selected {
  background-color: rgba(72, 255, 0, 0.1) !important;
}
.statistics-container .statistics-table-wrapper .statistics-table tr.highlight-red {
  background-color: rgba(255, 0, 0, 0.1);
}
.statistics-container .statistics-table-wrapper .statistics-table tr.fire-animation {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: left;
  background-repeat: no-repeat;
}
.statistics-container .statistics-table-wrapper .statistics-table td {
  padding: 6px;
  font-size: 16px;
  color: transparent;
  /* Делаем цвет текста прозрачным для отображения градиента */
  background: linear-gradient(to right, #000 0%, #000 80%, rgba(85, 85, 85, 0) 100%);
  /* Градиентный фон от серого к прозрачному */
  -webkit-background-clip: text;
  /* Для Chrome и Safari */
  background-clip: text;
  /* Стандартное свойство для других браузеров */
  position: relative;
  max-width: 30px;
  min-width: 20px;
  overflow: hidden;
  /* Убедитесь, что текст не вылезает из контейнера */
  white-space: nowrap;
  /* Запрещаем перенос строк */
}
.statistics-container .statistics-table-wrapper .statistics-table td:first-child {
  padding-left: 20px;
}
.statistics-container .statistics-table-wrapper .statistics-table a {
  color: #007bff;
  /* Пример цветовой переменной */
  text-decoration: none;
  font-weight: 500;
}
.statistics-container .statistics-table-wrapper .statistics-table a:hover {
  text-decoration: underline;
}

/* Обертка для кнопки "Лайк" */
.like-container {
  position: absolute;
  right: 10px;
  /* Отступ от правого края */
  bottom: 5px;
  /* Отступ от нижнего края */
  display: flex;
  align-items: center;
  /* Вертикально центрируем кнопку */
}

/* Стили для кнопки "Лайк" */
.like-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  /* Размер иконки */
  color: #ccc;
  transition: color 0.3s ease;
}

.like-button.liked .fa-heart {
  color: red;
  /* Цвет заполненного сердечка */
}

.like-button .fa-heart {
  color: #ccc;
  /* Цвет пустого сердечка */
}

.like-button:hover .fa-heart {
  color: #ff6b6b;
  /* Цвет сердечка при наведении */
}

.service-management p {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0.8em;
  color: #333;
}
.service-management .service-header {
  display: grid;
  grid-template-columns: 1fr 100px 150px 50px;
  gap: 10px;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
  margin-bottom: 15px;
}
.service-management .service-header .service-header-item {
  font-weight: 600;
  color: #555;
  font-size: 14px;
}
.service-management .service-item {
  display: grid;
  grid-template-columns: 1fr 100px 150px 50px;
  gap: 10px;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.service-management .service-item.approved {
  background-color: #f0f0f0;
  /* Серый фон для подтвержденных услуг */
  border-color: #d0d0d0;
  box-shadow: none;
}
.service-management .service-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}
.service-management .service-item .service-item-content {
  display: flex;
  align-items: center;
  color: #444;
  font-size: 14px;
  /* Основной контейнер для кастомного селектора */
  /* Стили для опций при открытии кастомного селектора */
  /* Показ меню при открытии */
  /* Стили для каждой опции в кастомном списке */
  /* Стили для опций при наведении */
}
.service-management .service-item .service-item-content .select-wrapper {
  position: relative;
  width: 100%;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background-color: #ffffff;
  color: #444;
  padding: 8px 12px;
  padding-right: 30px;
  /* Добавляем отступ справа, чтобы стрелка не накладывалась на текст */
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  /* Убираем стандартное оформление */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /* Кастомный стрелочный индикатор */
}
.service-management .service-item .service-item-content .select-wrapper:focus {
  border-color: #007bff;
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.2);
  outline: none;
}
.service-management .service-item .service-item-content .select-wrapper::after {
  content: "▼";
  position: absolute;
  right: 12px;
  /* Расположение стрелки */
  top: 50%;
  transform: translateY(-50%);
  color: #007bff;
  font-size: 14px;
  pointer-events: none;
  /* Стрелка не мешает кликам */
}
.service-management .service-item .service-item-content .select-wrapper select {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  padding: 8px 12px;
  padding-right: 30px;
  /* Совпадает с отступом справа у контейнера */
  cursor: pointer;
  position: relative;
  z-index: 2;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.service-management .service-item .service-item-content .custom-select-menu {
  display: none;
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  border: 1px solid #ddd;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}
.service-management .service-item .service-item-content .custom-select-menu.open {
  display: block;
}
.service-management .service-item .service-item-content .custom-select-menu .custom-option {
  padding: 8px 12px;
  color: #444;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.service-management .service-item .service-item-content .custom-select-menu .custom-option:hover {
  background-color: #f0f0f0;
}
.service-management .service-item .input-field {
  width: 50%;
  padding: 4px 6px;
  height: 100%;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  /* Явный фон для инпутов */
}
.service-management .service-item .input-field:disabled {
  background-color: #f9f9f9;
  /* Цвет фона для неактивных инпутов */
  border-color: #ccc;
}
.service-management .service-item .service-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.service-management .service-item .action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  max-width: 50px;
}
.service-management .service-item .icon-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  padding: 2px;
  transition: color 0.2s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.service-management .service-item .icon-button:hover {
  color: #0056b3;
  transform: scale(1.1);
}
.service-management .service-item .icon-button:disabled {
  color: #ccc;
  /* Цвет иконки для неактивных кнопок */
  cursor: not-allowed;
}
.service-management .service-item .confirm-button {
  color: #28a745;
}
.service-management .service-item .confirm-button.disabled {
  color: #ddd;
  /* Цвет для неактивной кнопки подтверждения */
}
.service-management .service-item .confirm-button.disabled-icon {
  color: #ddd;
  /* Цвет иконки для неактивной кнопки подтверждения */
}
.service-management .service-item .delete-button i {
  color: #ff4d4d;
}
.service-management .service-item .add-service-button i {
  color: #007bff;
  font-size: 24px;
}

.side-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color 0.3s ease;
  display: flex;
  justify-content: flex-start;
  z-index: 3000;
  overflow: hidden;
  pointer-events: none;
}
.side-modal.active {
  background-color: rgba(0, 0, 0, 0.4);
  pointer-events: all;
}
.side-modal__content {
  width: 40%;
  height: 96%;
  margin: 1%;
  background: #fff;
  padding: 30px 20px;
  border-radius: 20px;
  box-shadow: 2px 0 15px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  max-height: 100%;
  position: relative;
  transform: translateX(-100%);
  transition: transform 0.3s ease, opacity 0.3s ease;
  opacity: 0;
}
@media (max-width: 768px) {
  .side-modal__content {
    width: 100%;
  }
}
.side-modal.active .side-modal__content {
  opacity: 1;
  transform: translateX(0);
}
.side-modal__close {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  scale: 0.8;
  transition: scale 0.2s ease;
}
.side-modal__close:hover {
  scale: 1;
}

.checklist-container {
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
  font-family: "Arial", sans-serif;
}
.checklist-container .checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 16px;
  color: #333;
  position: relative;
}
.checklist-container .checkbox-container .checkbox-input {
  opacity: 0;
  position: absolute;
  cursor: pointer;
  z-index: 1;
}
.checklist-container .checkbox-container .checkbox-input:disabled {
  cursor: not-allowed;
}
.checklist-container .checkbox-container .checkmark {
  width: 24px;
  height: 24px;
  border: 1px solid #ccc;
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  margin-right: 12px;
}
.checklist-container .checkbox-container .checkmark::after {
  content: "";
  position: absolute;
  display: none;
  width: 8px;
  height: 16px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
}
.checklist-container .checkbox-container .checkbox-input:checked + .checkmark {
  background-color: #007bff;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
}
.checklist-container .checkbox-container .checkbox-input:checked + .checkmark::after {
  display: block;
}
.checklist-container .checkbox-container:hover .checkmark {
  background-color: #e6e6e6;
  border-color: #999;
}
.checklist-container .checkbox-container .checkbox-input:disabled + .checkmark {
  background-color: #f2f2f2;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.checklist-container .checkbox-container .checkbox-label {
  font-size: 16px;
  color: #333;
}
.checkbox-input:disabled + .checkmark + .checklist-container .checkbox-container .checkbox-label {
  color: #b3b3b3;
  cursor: not-allowed;
}
.checklist-container .checkbox-container .input-check {
  padding: 0px;
  width: calc(100% - 90px);
  height: 90%;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-right: 10px;
  font-size: 16px;
  transition: border-color 0.3s, box-shadow 0.3s;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.checklist-container .checkbox-container .input-check:hover {
  border-color: #999;
}
.checklist-container .checkbox-container .input-check:focus {
  border-color: #a1a1a1;
  outline: none;
  box-shadow: 0 0 8px rgba(110, 110, 110, 0.5);
}
.checklist-container .checkbox-container .input-check:disabled {
  background-color: #f5f5f5;
  border-color: #e0e0e0;
  cursor: not-allowed;
}
.checklist-container .checkbox-container button {
  padding: 8px 14px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  background-color: var(--primary-color);
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}
.checklist-container .checkbox-container button:hover {
  background-color: var(--primary-color);
}
.checklist-container input[type=text] {
  width: calc(100% - 40px);
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  margin-right: 10px;
  transition: border-color 0.3s;
}
.checklist-container input[type=text]:focus {
  border-color: var(--primary-color);
  outline: none;
}
.checklist-container button.add-button {
  padding: 8px 14px;
  font-size: 16px;
  background-color: var(--primary-color);
  border: none;
  border-radius: 200px;
  border: 2px solid var(--primary-color);
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}
.checklist-container button.add-button:hover {
  background-color: #fff;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
  box-shadow: 0 0 0 2px rgba(var(--primary-color), 0.5);
}

.average-time-task {
  padding: 20px;
  font-family: "Roboto", sans-serif;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.3);
  overflow: auto;
  max-height: 47vh;
}
.average-time-task .statistics-card {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.average-time-task .statistics-card .stats-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}
.average-time-task .statistics-card .stats-row p {
  font-size: 16px;
}
.average-time-task .statistics-card .stats-row .align-right {
  margin-left: auto;
}
.average-time-task .statistics-card h3 {
  font-size: 18px;
  color: #333;
}
.average-time-task .statistics-card .empty-state {
  text-align: center;
  padding: 20px;
  color: #999;
}
.average-time-task .statistics-card ul {
  list-style-type: none;
  padding: 0;
  margin: 1rem 0;
}
.average-time-task .statistics-card ul li {
  font-size: 1rem;
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-between;
}
.average-time-task .statistics-card ul li .statistic-value {
  font-weight: 600;
  color: #555;
}
.average-time-task .pie-chart {
  margin-top: 20px;
}
.average-time-task .recharts-wrapper {
  margin: 0 auto;
}
.average-time-task .recharts-tooltip-wrapper {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.average-time-task .recharts-legend-item {
  font-size: 14px;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  padding: 10px;
}
@media (max-width: 768px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}

.lena-style {
  display: flex;
  justify-content: flex-end;
  margin: 5px;
}
@media (max-width: 768px) {
  .lena-style {
    display: block;
  }
}

.monospace {
  font-family: "Courier New", Courier, monospace; /* Замените на желаемый моноширинный шрифт */
  white-space: nowrap; /* Убедитесь, что текст не переносится */
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/all.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB,kCAAA;AACA;EACE,WAAA;EACA,4BAAA;AAHF;;AAMA;EACE,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,2CAAA;AAHF;;AAMA;EACE,0CAAA;EACA,gCAAA;EACA,kBAAA;EACA,sCAAA;EACA,6BAAA;EACA,6CAAA;AAHF;;AAMA;EACE,oCAAA;EACA,kCAAA;AAHF;;AAOA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,mCAAA;EACA,wBAAA;EACA,kCAAA;EACA,8CAAA;EACA,kCAAA;EACA,yBAAA;AAJF;;AAQA;EACE,8BAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,mIAAA;AALF;;AAaA;EACE,iBAAA;EACA,YAAA;EACA,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;AAVF;;AAaA;EACE;IACE,sBAAA;EAVF;AACF;AAaA;;;EAGE,oBAAA;AAXF;;AAcA;EACE,aAAA;AAXF;;AAcA;EACE,qBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sCA3Fc;EA4Fd,sCAAA;EACA,kBAAA;EACA,eAAA;AAXF;AAaE;EACE,gBAAA;EACA,yBAAA;EACA,2BAnGY;EAoGZ,sCAAA;EACA,kBAAA;AAXJ;AAcE;EACE,sBAAA;EACA,WAAA;EACA,mBAAA;AAZJ;;AAgBA;EACE,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;AAbF;AAeE;EARF;IASI,UAAA;EAZF;AACF;;AAgBA;EACE,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EAAA,kBAAA;EACA,WAAA;EACA,sCArIc;EAsId,sCAAA;EACA,oBAAA;EACA,eAAA;AAbF;AAeE;EACE,gBAAA;EACA,yBAAA;EACA,2BA7IY;EA8IZ,sCAAA;AAbJ;AAgBE;EACE,sBAAA;EACA,WAAA;EACA,mBAAA;AAdJ;;AAmBA;EACE,mBAAA;AAhBF;;AAoBA;;EAEE,gBAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,2CAAA;AAjBF;AAoBE;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;AAlBJ;AAqBE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;AAnBJ;AAqBI;EACE,kBAAA;EACA,yBAAA;AAnBN;;AAwBA;EACE,gBAAA;EACA,iBAAA;AArBF;;AAyBA;EACE,eAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,SAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,wCAAA;EACA,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,oDAAA;EACA,aAAA;EACA,gBAAA;EACA,+DAAA;EAEA,6CAAA;AAvBF;AAwBE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AAtBJ;;AA0BA;;EAEE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;AAvBF;AAyBE;;EAEE,wCAAA;EACA,0CAAA;EACA,aAAA;AAvBJ;;AA4BA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAzBF;AA2BE;EALF;IAOI,eAAA;EAzBF;AACF;;AA4BA;EACE,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAzBF;AA2BE;EANF;IAQI,UAAA;IACA,eAAA;EAzBF;AACF;;AA4BA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAzBF;;AA6BA;EACE,aAAA;EACA,WAAA;EACA,oCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,wBAAA;AA1BF;AA4BE;EACE,UAAA;EACA,mBAAA;AA1BJ;AA6BE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wCAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;AA3BJ;AA6BI;EACE,mBAAA;AA3BN;AA8BI;EAdF;IAeI,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,+CAAA;EA3BJ;AACF;AA6BI;EACE,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3BN;AA6BM;EACE,UAAA;AA3BR;AA8BM;EACE,oCAAA;EACA,mBAAA;AA5BR;AA+BM;EACE,oCAAA;AA7BR;AAgCM;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA9BR;AA+BQ;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA7BV;AA+BU;EACE,kBAAA;EACA,uCAAA,EAAA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA,EAAA,kCAAA;EACA,kBAAA,EAAA,kCAAA;EACA,kBAAA,EAAA,uCAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA,EAAA,0BAAA;EACA,qBAAA,EAAA,yBAAA;EACA,qBAAA,EAAA,kCAAA;EACA,UAAA;EACA,mDAAA;EAEA,wBAAA;EACA,wCAAA,EAAA,oBAAA;EACA,0CAAA,EAAA,mBAAA;AA9BZ;AAiCU;EACE,mBAAA;EACA,UAAA;AA/BZ;AAmCQ;EACE,kBAAA;AAjCV;AAmCU;EACE,eAAA;EACA,+BAAA;EACA,2BAAA;EACA,0BAAA;EACA,kBAAA;EAEA,mCAAA;AAlCZ;AAmCY;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sCAAA;EACA,eAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;AAjCd;AAoCY;EACE,yBAAA;EACA,kDAAA;AAlCd;AAqCY;EACE,cAAA;EACA,kCAAA;AAnCd;AAuCU;EACE,aAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;EACA,6BAAA;AArCZ;AAuCY;EACE,aAAA;AArCd;AAwCY;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAtCd;AAwCc;EACE,kBAAA;AAtChB;AAwCgB;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kDAAA;EACA,+BAAA;AAtClB;AAwCkB;EACE,sBAAA;EACA,YAAA;AAtCpB;AA4CY;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AA1Cd;AA4Cc;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AA1ChB;AA4CgB;EACE,sBAAA;AA1ClB;AA6CgB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA3ClB;AA8CgB;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA5ClB;AAmDQ;EACE,aAAA;EACA,eAAA;EACA,8BAAA;AAjDV;AAmDU;EACE,aAAA;EACA,SAAA;AAjDZ;AAoDU;EACE,SAAA;EACA,aAAA;EACA,WAAA;AAlDZ;AAoDY;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;AAlDd;AAqDY;EACE,cAAA;AAnDd;AAsDY;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;AApDd;AAyDQ;EACE,aAAA;AAvDV;AA0DQ;EACE,2BA9iBM;EA+iBN,kBAAA;AAxDV;AA2DQ;EACE,aAAA;EACA,0BAAA;EACA,gBAAA;AAzDV;AA2DU;EACE,YAAA;AAzDZ;AA6DQ;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AA3DV;AAiEE;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,8BAAA;EACA,YAAA;EACA,0BAAA;AA/DJ;AAiEI;EACE,qBAAA;AA/DN;AAmEE;EA3TF;IA4TI,+CAAA;EAhEF;AACF;;AAoEA;EACE,oCAAA;EACA,gBAAA;AAjEF;;AAoEA;EACE,2BApmBc;EAqmBd,kBAAA;AAjEF;AAmEE;EACE,kBAAA;EACA,cAAA;EACA,sCA1mBY;AAyiBhB;;AAsEA;EACE,WAAA;EACA,sCAjnBc;EAknBd,yBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;AAnEF;AAqEE;EACE,oCAAA;EACA,2BA9nBY;EA+nBZ,kBAAA;EACA,sCAAA;AAnEJ;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AArEF;;AAwEA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AArEF;AAuEE;EACE,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,kGAAA;EAEA,mCAAA;EACA,wEAAA;AAtEJ;AAwEI;EAEE,eAAA;EACA,gFAAA;AAvEN;AA2EI;EAEE,eAAA;EACA,8EAAA;AA1EN;AA8EI;EAEE,eAAA;EACA,gFAAA;AA7EN;AAiFI;EAEE,eAAA;EACA,gFAAA;AAhFN;AAoFI;EAEE,uBAAA;EACA,iFAAA;AAnFN;;AA0FA;EACE;IAEE,iGAAA;EAxFF;EA4FA;IACE,iGAAA;EA1FF;EA8FA;IACE,iGAAA;EA5FF;EAgGA;IACE,iGAAA;EA9FF;AACF;AAmGA;EACE;IAEE,+FAAA;EAlGF;EAsGA;IACE,+FAAA;EApGF;EAwGA;IACE,+FAAA;EAtGF;EA0GA;IACE,+FAAA;EAxGF;AACF;AA6GA;EACE;IAGE,eAAA;EA7GF;EAgHA;IACE,eAAA;EA9GF;EAiHA;IACE,eAAA;EA/GF;EAkHA;IACE,eAAA;EAhHF;EAmHA;IACE,eAAA;EAjHF;EAoHA;IACE,eAAA;EAlHF;EAqHA;IACE,eAAA;EAnHF;AACF;AAuHA;EACE;IAGE,uBAAA;EAvHF;EA0HA;IACE,sBAAA;EAxHF;EA2HA;IACE,uBAAA;EAzHF;EA4HA;IACE,sBAAA;EA1HF;EA6HA;IACE,uBAAA;EA3HF;EA8HA;IACE,sBAAA;EA5HF;EA+HA;IACE,uBAAA;EA7HF;AACF;AAgIA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AA9HF;;AAiIA;EACE,kBAAA;EACA,2BAAA;AA9HF;;AAiIA;EACE,aAAA;AA9HF;;AAiIA;EACE;IACE,aAAA;IACA,uBAAA;IACA,kBAAA;IACA,eAAA;IACA,eAAA;IACA,0CAAA;IACA,aAAA;IACA,mBAAA;EA9HF;EAiIA;IACE,qBAAA;IACA,gBAAA;IACA,+BAAA;IACA,sBAAA;EA/HF;EAkIA;IACE,yBAAA;IACA,6BAAA;EAhIF;EAmIA;IACE,YAAA;EAjIF;EAoIA;IACE,iBAAA;IACA,uBAAA;IACA,aAAA;IAMA,4DAAA;EAvIF;EAmIE;IACE,YAAA;EAjIJ;EAqIE;IACE,YAAA;EAnIJ;EAuIA;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;EArIF;EAwIA;IACE,aAAA;EAtIF;AACF;AAyIA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAvIF;AA0IE;EACE,UAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAxIJ;AA2II;EACE,mBAAA;AAzIN;AA8IE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oFAAA;EAEA,kBAAA;AA7IJ;AAgJI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,QAAA;EACA,SAAA;EACA,8CAAA;AA9IN;AAmJE;EACE,yBAAA;EACA,qBAAA;EACA,4CAAA;AAjJJ;AAmJI;EACE,cAAA;AAjJN;AAsJE;EACE,yBAAA;EACA,kBAAA;AApJJ;AAwJE;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;AAtJJ;AA0JE;EACE,eAAA;EACA,WAAA;AAxJJ;AA2JI;EACE,cAAA;EACA,mBAAA;AAzJN;;AA8JA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,wCAAA;EACA,gBAAA;EACA,kBAAA;AA3JF;AA6JE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AA3JJ;AA6JI;EACE,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AA3JN;AA8JI;EACE,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,2DAAA;EACA,wCAAA;EACA,sBAAA;EACA,yBAAA;AA5JN;AA8JM;EACE,sCAAA;EACA,gCAAA;AA5JR;AA+JM;EACE;IACE,sCAAA;EA7JR;EAgKM;IACE,sCAAA;EA9JR;EAiKM;IACE,sCAAA;EA/JR;AACF;AAkKM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAhKR;AAmKM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAjKR;AAmKQ;EACE,SAAA;EACA,eAAA;EACA,WAAA;AAjKV;AAoKQ;EACE,SAAA;EACA,eAAA;EACA,WAAA;AAlKV;AAqKQ;;EAEE,iBAAA;EACA,WAAA;EACA,eAAA;AAnKV;AAsKQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AApKV;AAsKU;EACE,YAAA;EAAA,cAAA;EAAA,4BAAA;EACA,2BAAA;EACA,kBAAA;AApKZ;AAsKY;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kDAAA;EACA,+BAAA;AApKd;AAsKc;EACE,sBAAA;EACA,YAAA;AApKhB;AA0KQ;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AAxKV;AA0KU;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AAxKZ;AA0KY;EACE,sBAAA;AAxKd;AA2KY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAzKd;AA4KY;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA1Kd;AAkLE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gDAAA;AAhLJ;AAkLI;EACE,WAAA;EACA,qBAAA;AAhLN;AAoLE;EACE,aAAA;EACA,gBAAA;AAlLJ;;AAsLA,yCAAA;AACA;EACE;IACE,qBAAA;EAnLF;EAsLA;IACE,sBAAA;IACA,uBAAA;EApLF;AACF;AAuLA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,SAAA;AArLF;;AAwLA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;AArLF;;AAwLA;EACE;IACE,uBAAA;EArLF;EAwLA;IACE,yBAAA;EAtLF;AACF;AAyLA;EACE,YAAA;EACA,YAAA;EACA,sCAjrCc;EAkrCd,YAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAvLF;AAyLE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;AAvLJ;;AA4LA;EACE;IACE,eAAA;EAzLF;EA4LA;IACE,cAAA;EA1LF;EA4LE;;IAEE,WAAA;EA1LJ;EA8LA;;IAEE,WAAA;IACA,iBAAA;EA5LF;EA+LA;IACE,gBAAA;IACA,mBAAA;EA7LF;EAgMA;IACE,sBAAA;IACA,oBAAA;EA9LF;AACF;AAiMA;EACE,aAAA;EACA,2DAAA;EACA,kFAAA;EACA,cAAA;EACA,4BAAA;EACA,uBAAA;EACA,yCAAA;AA/LF;;AAkMA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,wCAAA;AA/LF;;AAkMA;EACE;IACE,0BAAA;IACA,4DAAA;EA/LF;AACF;AAkMA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAhMF;AAkME;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EAmCA,2DAAA;EAkBA,yDAAA;AAnPJ;AAgMI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AA9LN;AAgMM;EACE,WAAA;AA9LR;AAiMM;EACE,qCAAA;AA/LR;AAmMI;EACE;IACE,0CAAA;EAjMN;EAoMI;IACE,2CAAA;EAlMN;EAqMI;IACE,0CAAA;EAnMN;AACF;AAuMI;EACE,sCAxyCU;EAyyCV,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,2CAAA;AArMN;AAyMI;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,2CAAA;AAvMN;AA0MI;EACE,qBAAA;AAxMN;AA4ME;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,2CAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AA1MJ;AA4MI;EACE,QAAA;AA1MN;AA6MI;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;AA3MN;AA6MM;EACE,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AA3MR;AA6MQ;EACE,0CAAA;EACA,2BAl3CM;AAuqChB;AA8MQ;EACE,0CAAA;AA5MV;AA+MQ;EACE,aAAA;AA7MV;AAkNI;EACE,gBAAA;EACA,UAAA;AAhNN;AAkNM;EACE,2CAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,2CAAA;EACA,2CAAA;AAhNR;AAkNQ;EACE,2BAAA;EACA,2CAAA;AAhNV;AAmNQ;EACE,iBAAA;EACA,0CAAA;AAjNV;AAoNQ;EACE,aAAA;EACA,mEACE;EAEF,+BAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,2CAAA;EACA,2CAAA;AApNV;AAuNQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AArNV;AAwNQ;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;AAtNV;AAyNQ;EACE,kCAAA;EACA,eAAA;EACA,iBAAA;AAvNV;AA0NQ;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAxNV;AA2NQ;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;AAzNV;AA4NQ;EACE,cAAA;AA1NV;AAgOE;EA5NF;IA6NI,WAAA;IACA,YAAA;EA7NF;EA+NE;IACE,WAAA;IACA,YAAA;EA7NJ;EAgOE;;IAEE,WAAA;IACA,YAAA;IACA,eAAA;EA9NJ;EAiOE;IACE,WAAA;IACA,aAAA;EA/NJ;EAiOI;IACE,YAAA;IACA,eAAA;EA/NN;EAkOI;IACE,eAAA;EAhON;EAmOI;IACE,eAAA;EAjON;EAoOI;IACE,eAAA;EAlON;AACF;;AAuOA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,wBAAA;EACA,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,yCAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AApOF;AAsOE;EACE,cAAA;EACA,0CAAA;EACA,qBAAA;EAEA,kBAAA;AArOJ;AAsOI;EACE,yBAAA;EACA,oBAAA;AApON;AAwOE;EACE,cAAA;EACA,4CAAA;EACA,qBAAA;EAEA,kBAAA;AAvOJ;AAwOI;EACE,yBAAA;EACA,oBAAA;AAtON;AA0OE;EACE,mCAAA;AAxOJ;AA2OE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;EACA,6BAAA;AAzOJ;;AA6OA;EACE;IAEE,UAAA;IACA,wBAAA;EA3OF;EA8OA;IAEE,UAAA;IACA,0BAAA;EA7OF;AACF;AAgPA;EACE;IACE,WAAA;EA9OF;EAiPA;IACE,QAAA;EA/OF;AACF;AAuPA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AArPF;;AAwPA;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,YAAA;EACA,uCAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArPF;AAuPE;EACE,eAAA;EACA,mBAAA;AArPJ;AAwPE;EACE,gBAAA;EACA,UAAA;AAtPJ;AAyPE;EACE,kBAAA;AAvPJ;AAyPI;EACE,iBAAA;AAvPN;;AA4PA;EACE,kBAAA;EACA,YA5Ca;EA6Cb,aA5Cc;EA6Cd,iBAAA;EACA,kBA7CqB;EA8CrB,gBAAA;EACA,eAAA;AAzPF;AA2PE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzPJ;AA6PI;EACE,aAAA;AA3PN;;AAgQA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YApEa;EAqEb,aApEc;EAqEd,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,kBA1EqB;AAnLvB;AA+PE;EACE,eAAA;AA7PJ;;AAiQA;EACE,eAAA;EACA,kBAAA;AA9PF;;AAiQA;EACE,aAAA;AA9PF;;AAkQA;EACE;IACE,WAAA;IACA,cAAA;EA/PF;AACF;AAkQA;EACE,aAAA;EACA,2BAAA;EACA,SAAA;AAhQF;AAkQE;EACE,kBAAA;EACA,qBAAA;AAhQJ;AAkQI;EACE,uBAAA;EACA,2BAlsDU;EAmsDV,YAAA;EACA,YAAA;EACA,sCAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;AAhQN;AAkQM;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;AAhQR;AAmQM;EACE,sCAttDQ;EAutDR,WAAA;AAjQR;AAmQQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAjQV;AAmQU;EACE,2BAhuDI;EAiuDJ,kBAAA;EACA,sBAAA;AAjQZ;AAsQM;EACE,iBAAA;EACA,eAAA;EACA,eAAA;EACA,2BA3uDQ;AAu+ChB;AAsQQ;EACE,6BA/uDQ;AA2+ClB;AAyQI;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sCAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;AAvQN;AAyQM;EACE,6BAAA;EACA,kBAAA;EACA,YAAA;AAvQR;AAyQQ;EACE,mBAAA;AAvQV;AA0QQ;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAxQV;AA2QQ;EACE,sCAlxDM;EAmxDN,YAAA;AAzQV;;AAgRA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AA7QF;AA+QE;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AA7QJ;AA+QI;EACE,kBAAA;AA7QN;AAgRI;EACE,aAAA;EACA,kBAAA;AA9QN;;AAuRA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,yCA7zDiB;EA8zDjB,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AApRF;AAsRE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AApRJ;AAuRE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AArRJ;AAwRE;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,6DAAA;EAiGA,wCAAA;EASA,0BAAA;AA9XJ;AAsRI;EACE,aAAA;EACA,sCA91DU;EA+1DV,mBAAA;EACA,sCAAA;EACA,gBAAA;EACA,qCAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EAEA,gDAAA;AArRN;AAsRM;;EAEE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,eAAA;EACA,UAAA;EACA,wCAAA;AApRR;AAwRI;EACE,aAAA;EACA,mBAAA;EACA,8CAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,iDAAA;EACA,oBAAA;EAEA,wDAAA;AAvRN;AAwRM;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,4CAAA;EACA,gBAAA;EACA,gDAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;AAtRR;AAwRQ;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,eAAA;EACA,UAAA;EACA,wCAAA;AAtRV;AAyRQ;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,wCAAA;AAvRV;AAyRU;EACE,gBAAA;EACA,YAAA;EACA,cAxHE;EAyHF,eAAA;EACA,eAAA;EACA,2BAAA;AAvRZ;AAyRY;EACE,cAAA;AAvRd;AA+RI;EACE;;IAEE,UAAA;IACA,4CAAA;EA7RN;AACF;AAiSI;EACE;;IAEE,UAAA;IACA,yBAAA;EA/RN;AACF;AAmSE;;EAEE,aAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,qDAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sCAAA;AAjSJ;AAmSI;;EACE,sBAAA;EACA,uCAAA;AAhSN;;AAqSA;EACE,aAAA;EACA,oBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,gCAAA;AAlSF;;AAqSA,wCAAA;AACA;EACE;IACE,kBAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;IACA,uCAAA;IACA,2CAAA;EAlSF;AACF;AAqSA;EACE,YAAA;AAnSF;AAqSE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AAnSJ;AAqSI;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sCAAA;AAnSN;AAqSM;EACE,yBAAA;AAnSR;AAsSM;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AApSR;AAsSQ;EACE,SAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AApSV;AAwSM;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AAtSR;AAwSQ;EACE,yBAAA;AAtSV;AA2SI;EACE,kBAAA;EACA,sBAAA;AAzSN;AA2SM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AAzSR;AA2SQ;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,sCAAA;EACA,8BAAA;AAzSV;AA2SU;EACE,mBAAA;AAzSZ;AA4SU;EACE,yBAAA;AA1SZ;AA6SU;EACE,cAAA;EACA,WAAA;EACA,eAAA;AA3SZ;AA8SU;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AA5SZ;AA8SY;EACE,cAAA;AA5Sd;;AAqTA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,cAAA;AAlTF;AAoTE;EACE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAlTJ;AAoTI;;EAEE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAlTN;AAoTM;;EACE,yBAAA;EACA,cAAA;AAjTR;AAoTM;;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAjTR;AAmTQ;;EACE,aAAA;EACA,qBAAA;AAhTV;AAqTI;EACE,sCAtoEU;EAuoEV,WAAA;EACA,iBAAA;AAnTN;AAwTQ;EACE,yBAAA;AAtTV;AAyTQ;EACE,yBAAA;AAvTV;AA2TU;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;AAzTZ;AA4TU;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AA1TZ;AA4TY;EACE,wBAAA;AA1Td;AA6TY;EACE,qBAAA;AA3Td;AA8TY;EACE,sBAAA;AA5Td;AA+TY;EACE,sBAAA;AA7Td;AAgUY;EACE,uBAAA;AA9Td;AAkUU;EACE,yBAAA;EACA,cAAA;AAhUZ;;AAwUA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AArUF;;AAwUA;EACE,YAAA;AArUF;;AAwUA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AArUF;AAuUE;EACE,wBAAA;AArUJ;AAwUE;EACE,qBAAA;AAtUJ;AAyUE;EACE,sBAAA;AAvUJ;AA0UE;EACE,sBAAA;AAxUJ;AA2UE;EACE,uBAAA;AAzUJ;;AA+UA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;AA5UF;AA8UE;EACE,kBAAA;EACA,mBAAA;AA5UJ;AA+UE;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AA7UJ;AA+UI;;EAEE,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AA7UN;AAgVI;EACE,yBAAA;AA9UN;;AAmVA;EACE,aAAA;EACA,SAAA;EACA,YAAA;EAEA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAjVF;AAmVE;EACE,qBAAA;AAjVJ;AAoVE;EACE,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAlVJ;AAoVI;EACE,kBAAA;AAlVN;AAqVI;EACE,aAAA;EACA,kBAAA;AAnVN;;AA2VE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;AAxVJ;AA2VE;EACE,aAAA;EACA,2CAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AAzVJ;AA2VI;EACE,gBAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;AAzVN;AA6VE;EACE,aAAA;EACA,2CAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;EACA,uDAAA;AA3VJ;AA6VI;EACE,2BAAA;EACA,yCAAA;AA3VN;AA8VI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;AA5VN;AA+VI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA7VN;AAgWI;EACE,aAAA;EACA,QAAA;EACA,wCAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;AA9VN;AAiWI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/VN;AAkWI;EACE,cAAA;EACA,qBAAA;AAhWN;AAmWI;EACE,cAAA;EACA,yBAAA;AAjWN;AAoWI;EACE,cAAA;EACA,yBAAA;EACA,eAAA;EACA,8BAAA;AAlWN;;AAuWA;EACE,eAAA;EACA,2BAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AApWF;AAsWE;EACE,YAAA;EACA,sCA95EY;EA+5EZ,qBAAA;AApWJ;;AAwWA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,cAAA;AArWF;AAuWE;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wCAAA;AArWJ;AAuWI;;EAEE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AArWN;AAuWM;;EACE,YAAA;EACA,WAAA;EACA,mCAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AApWR;AAwWI;EACE,iDAAA;EACA,cAAA;EACA,iBAAA;AAtWN;AAwWM;EACE,mBAAA;EACA,YAAA;EAEA,+BAAA;AAvWR;AAwWQ;EACE,aAAA;AAtWV;AAyWQ;EACE,WAAA;AAvWV;AA4WI;EACE,yBAAA;EACA,uBAAA;AA1WN;AA6WI;EACE,yBAAA;EACA,uBAAA;AA3WN;AA8WI;EACE,yBAAA;EACA,sDAAA;AA5WN;AA+WI;EACE,yBAAA;EACA,sDAAA;AA7WN;AAkXQ;EACE,yBAAA;AAhXV;AAmXQ;EACE,oCAAA;AAjXV;AAoXQ;EACE,iBAAA;AAlXV;AAoXU;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAlXZ;AAqXU;EACE,yBAAA;EACA,cAAA;AAnXZ;AA0XE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAxXJ;AA0XI;EACE,kBAAA;AAxXN;AA4XE;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;EACA,mBAAA;AA1XJ;AA4XI;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AA1XN;AA6XI;EACE,qBAAA;EACA,UAAA;AA3XN;AA6XM;EACE,aAAA;EACA,6BAAA;EACA,eAAA;EACA,WAAA;AA3XR;AA6XQ;EACE,mBAAA;AA3XV;AA8XQ;EACE,cAAA;AA5XV;AA+XQ;EACE,cAAA;AA7XV;;AA6YA;EACE,UAAA;EACA,sBAAA;AA1YF;AA4YE;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,yBAjBa;EAkBb,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAnBsB;EAoBtB,kBAAA;EACA,6BAAA;EACA,mBAAA;AA1YJ;AA6YE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,yBAhCa;EAiCb,kBAAA;AA3YJ;AA8YE;EACE,yBAAA;EACA,WAAA;EACA,yBAvCa;EAwCb,kBAAA;EACA,mBAAA;AA5YJ;AA8YI;EACE,yDAAA;EACA,wBAAA;EACA,yBAAA;EACA,4BAAA;AA5YN;AA+YI;EACE,gBAAA;EACA,MAAA;EACA,yBApDkB;EAqDlB,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAvDoB;EAwDpB,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7YN;AAgZI;EACE,sCA7nFU;EA8nFV,WAAA;AA9YN;AAiZI;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AA/YN;AAiZM;EACE,kBAAA;EACA,iBAAA;AA/YR;AAkZM;EACE,2BAjpFQ;EAkpFR,qBAAA;EACA,gBAAA;AAhZR;AAkZQ;EACE,0BAAA;AAhZV;AAqZI;EACE,sCAAA;AAnZN;AAqZM;EACE,yBA9FiB;AArTzB;AAsZM;EACE,oCAAA;AApZR;AAuZM;EACE,iDAAA;AArZR;AAwZM;EACE,kDAAA;AAtZR;AA2ZE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAzZJ;;AA6ZA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,wCAAA;AA1ZF;AA4ZE;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;AA1ZJ;AA6ZE;EACE,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EAEA,2BAAA;AA5ZJ;AA6ZI;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6DAAA;EACA,WAAA;EACA,yBAAA;AA3ZN;AA6ZM;EACE,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,UAAA;EACA,gBAAA;AA3ZR;AA6ZQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,yFAAA;EAKA,oBAAA;EACA,uCAAA;AA/ZV;AAkaQ;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,sCAAA;EACA,oCAAA;AAhaV;AAkaU;EACE,oCAAA;AAhaZ;AAoaQ;EACE,sCAnwFM;EAowFN,cAAA;AAlaV;AAoaU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,2FAAA;EAKA,oBAAA;EACA,uCAAA;AAtaZ;AA2aM;EACE,sCAAA;AAzaR;AA2aQ;EACE,yBAAA;AAzaV;AA4aQ;EACE,oCAAA;AA1aV;AA6aQ;EACE,kDAAA;AA3aV;AA8aQ;EACE,sCAAA;AA5aV;AA+aQ;EACE,yDAAA;EACA,wBAAA;EACA,yBAAA;EACA,4BAAA;AA7aV;AAibM;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,4DAAA;EACA,kFAAA;EAMA,4CAAA;EACA,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,8CAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,mBAAA;EACA,4BAAA;AApbR;AAubM;EACE,kBAAA;AArbR;AAwbM;EACE,cAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;AAtbR;AAybM;EACE,0BAAA;AAvbR;;AA6bA,8BAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;AA1bF;;AA6bA,4BAAA;AACA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,2BAAA;AA1bF;;AA6bA;EACE,UAAA;EACA,+BAAA;AA1bF;;AA6bA;EACE,WAAA;EACA,0BAAA;AA1bF;;AA6bA;EACE,cAAA;EACA,gCAAA;AA1bF;;AA8bE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;AA3bJ;AA8bE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AA5bJ;AA8bI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AA5bN;AAgcE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;EACA,uDAAA;AA9bJ;AAgcI;EACE,yBAAA;EACA,uCAAA;EACA,qBAAA;EACA,gBAAA;AA9bN;AAicI;EACE,2BAAA;EACA,yCAAA;AA/bN;AAkcI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EAEA,gDAAA;EA2DA,sDAAA;EAgBA,4BAAA;EAKA,8CAAA;EASA,kCAAA;AAthBN;AA8bM;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,qEAAA;EACA,wDAAA;EAEA,mCAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EAQA,mCAAA;AApcR;AA8bQ;EACE,qBAAA;EACA,0CAAA;EACA,aAAA;AA5bV;AAgcQ;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,6BAAA;AA9bV;AAicQ;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AA/bV;AAocM;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAlcR;AAscM;EACE,cAAA;AApcR;AAwcM;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,sCAAA;AAtcR;AA0cM;EACE,yBAAA;AAxcR;AA4cI;EACE,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AA1cN;AA6cI;EACE,yBAAA;EACA,qCAAA;EACA,kBAAA;AA3cN;AA8cI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA5cN;AA+cI;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA7cN;AAgdI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9cN;AAidI;EACE,cAAA;EACA,qBAAA;AA/cN;AAkdI;EACE,WAAA;EACA,sCAAA;EACA,mBAAA;AAhdN;AAmdI;EACE,cAAA;AAjdN;AAodI;EACE,WAAA;EACA,6CAAA;AAldN;AAqdI;EACE,WAAA;EACA,oDAAA;AAndN;AAsdI;EACE,cAAA;AApdN;AAudI;EACE,cAAA;EACA,eAAA;AArdN;;AA0dA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,sCAAA;EACA,aAAA;EACA,2BAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AAvdF;AAydE;EACE,oCAAA;EACA,mBAAA;AAvdJ;AA0dE;EACE,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kDAAA;EACA,UAAA;AAxdJ;AAydI;EAdF;IAeI,WAAA;EAtdJ;AACF;AAwdI;EACE,UAAA;EACA,wBAAA;AAtdN;AA0dE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,2BAAA;AAxdJ;AA0dI;EACE,QAAA;AAxdN;;AA6dA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AA1dF;AA4dE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AA1dJ;AA6dI;EACE,UAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AA3dN;AA8dM;EACE,mBAAA;AA5dR;AAieI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oFAAA;EAEA,kBAAA;AAheN;AAmeM;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,QAAA;EACA,SAAA;EACA,8CAAA;AAjeR;AAseI;EACE,yBAAA;EACA,qBAAA;EACA,4CAAA;AApeN;AAseM;EACE,cAAA;AApeR;AAyeI;EACE,yBAAA;EACA,kBAAA;AAveN;AA2eI;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;AAzeN;AA6eI;EACE,eAAA;EACA,WAAA;AA3eN;AA8eM;EACE,cAAA;EACA,mBAAA;AA5eR;AAgfI;EACE,YAAA;EACA,wBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,8CAAA;EACA,wCAAA;AA9eN;AAgfM;EACE,kBAAA;AA9eR;AAifM;EACE,qBAAA;EACA,aAAA;EACA,4CAAA;AA/eR;AAkfM;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;AAhfR;AAofI;EACE,iBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,sCAlyGU;EAmyGV,YAAA;EACA,eAAA;EACA,iCAAA;AAlfN;AAofM;EACE,sCAxyGQ;AAszFhB;AAufE;EACE,wBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;AArfJ;AAufI;EACE,kCAvzGU;EAwzGV,aAAA;AArfN;AAyfE;EACE,iBAAA;EACA,eAAA;EACA,sCA/zGY;EAg0GZ,YAAA;EACA,oBAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AAvfJ;AAyfI;EACE,sBAAA;EACA,2BAz0GU;EA00GV,sCAAA;EACA,qDAAA;AAvfN;;AA4fA;EACE,aAAA;EACA,iCAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,cAAA;EACA,gBAAA;AAzfF;AA2fE;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;AAzfJ;AA2fI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AAzfN;AA2fM;EACE,eAAA;AAzfR;AA4fM;EACE,iBAAA;AA1fR;AA8fI;EACE,eAAA;EACA,WAAA;AA5fN;AA+fI;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AA7fN;AAggBI;EACE,qBAAA;EACA,UAAA;EACA,cAAA;AA9fN;AAggBM;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AA9fR;AAggBQ;EACE,gBAAA;EACA,WAAA;AA9fV;AAogBE;EACE,gBAAA;AAlgBJ;AAqgBE;EACE,cAAA;AAngBJ;AAsgBE;EACE,yCAAA;AApgBJ;AAugBE;EACE,eAAA;AArgBJ;;AAygBA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,aAAA;AAtgBF;AAwgBE;EANF;IAOI,0BAAA;EArgBF;AACF;;AAwgBA;EACE,aAAA;EACA,yBAAA;EACA,WAAA;AArgBF;AAsgBE;EAJF;IAKI,cAAA;EAngBF;AACF;;AAqgBA;EACE,8CAAA,EAAA,4CAAA;EACA,mBAAA,EAAA,wCAAA;AAlgBF","sourcesContent":["$secondary-color: var(--secondary-color);\n$primary-color: var(--primary-color);\n$background-color: var(--background-color);\n\n// Общие стили для всего сайта\n/* Кастомизация полосы прокрутки */\n::-webkit-scrollbar {\n  width: 10px;\n  /* Ширина полосы прокрутки */\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.5);\n  /* Цвет фона полосы прокрутки */\n  border-radius: 8px;\n  /* Скругление углов фона полосы прокрутки */\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: rgba(255, 255, 255, 0.7);\n  /* Цвет самой полосы прокрутки */\n  border-radius: 8px;\n  /* Скругление углов полосы прокрутки */\n  border: 2px solid transparent;\n  /* Прозрачная рамка вокруг полосы прокрутки */\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: rgb(255, 255, 255);\n  /* Изменение цвета при наведении */\n}\n\n// Сброс стилей\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  /* Для Chrome и Safari */\n  text-rendering: optimizeLegibility;\n  /* Оптимизирует четкость и читаемость текста */\n  -moz-osx-font-smoothing: grayscale;\n  /* Для Firefox на MacOS */\n}\n\n// Основные стили для элементов страницы\nbody {\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  color: #333;\n  min-height: 100vh;\n  background: linear-gradient(\n    1.63deg,\n    $background-color 3.46%,\n    $background-color 51.09%,\n    $background-color 96.78%\n  );\n}\n\n#app-background {\n  min-height: 100vh;\n  height: 100%;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  #app-background {\n    background-size: cover; // при необходимости можно изменить на contain\n  }\n}\n\nh1,\nh2,\nh3 {\n  margin-bottom: 0.5em;\n}\n\n.file-input {\n  display: none;\n}\n\n.file-upload-label {\n  display: inline-block;\n  padding: 7px;\n  color: white;\n  font-size: 16px;\n  text-decoration: none;\n  width: fit-content;\n  background-color: $primary-color;\n  border: 2px solid $primary-color;\n  border-radius: 8px;\n  cursor: pointer;\n\n  &:hover {\n    transition: 0.5s;\n    background-color: #ffffff;\n    color: $primary-color;\n    border: 2px solid $primary-color;\n    border-radius: 8px;\n  }\n\n  &:disabled {\n    background-color: #ccc;\n    color: #666;\n    cursor: not-allowed;\n  }\n}\n\n.form-container {\n  width: 50%;\n  background-color: #ffffff;\n  margin: 50px auto;\n  padding: 20px 10px;\n  border-radius: 16px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.9);\n\n  @media (max-width: 768px) {\n    width: 94%;\n  }\n}\n\n// Общие стили для кнопок\nbutton {\n  display: inline-block;\n  padding: 10px 20px;\n  text-decoration: none;\n  font-size: 16px;\n  margin: 5px;\n  width: fit-content;\n  color: #fff;\n  background-color: $primary-color;\n  border: 2px solid $primary-color;\n  border-radius: 200px;\n  cursor: pointer;\n\n  &:hover {\n    transition: 0.5s;\n    background-color: #ffffff;\n    color: $primary-color;\n    border: 2px solid $primary-color;\n  }\n\n  &:disabled {\n    background-color: #ccc;\n    color: #666;\n    cursor: not-allowed;\n  }\n}\n\n// Общие стили для блоков\n.block {\n  margin-bottom: 20px;\n}\n\n// Общие стили для списков\nul,\nol {\n  list-style: none;\n}\n\n.options-list {\n  list-style: none;\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  position: absolute;\n  z-index: 1000;\n  /* Установите достаточно высокий z-индекс */\n  // Другие стили\n\n  &.has-border {\n    border-radius: 8px;\n    background-color: #fbfbfb;\n    border: 1px solid #ccc;\n  }\n\n  &-item {\n    padding: 8px;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      border-radius: 8px;\n      background-color: #f1f1f1;\n    }\n  }\n}\n\n.selected-option {\n  margin-top: 10px;\n  font-weight: bold;\n}\n\n// Общие стили для изображений\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n.input-auto-height {\n  flex: 1;\n  padding: 5px;\n  background-color: #ffffff;\n  resize: none;\n  align-content: center;\n  border: 1px solid $secondary-color;\n  max-height: 200px;\n  /* Максимальная высота */\n  height: auto;\n  /* Автоматическая высота в зависимости от контента */\n  outline: none;\n  overflow-y: auto;\n  /* Добавим скролл, если контент превышает максимальную высоту */\n\n  /* Убираем стандартное выделение у textarea */\n  &:focus-within {\n    border-color: none;\n    /* Цвет выделения */\n    box-shadow: none;\n    /* Тень вокруг контейнера */\n  }\n}\n\ninput,\ntextarea {\n  width: 100%;\n  font-size: 16px;\n  border-radius: 8px;\n  font-family: Arial, sans-serif;\n  height: 45px;\n  border: 1px solid $secondary-color;\n  padding: 10px; // Добавляем отступ вокруг текста внутри элемента\n\n  &:focus {\n    // Стили для выбранного инпута\n    border: 1px solid $secondary-color;\n    box-shadow: 0 0 5px $secondary-color;\n    outline: none; // Убираем стандартное синее подчеркивание при фокусировке\n  }\n}\n\n// Общие стили для заголовков\n.headerTitle {\n  text-align: center;\n  font-size: 44px; // Базовый размер для десктопов\n  margin-top: 15px;\n\n  @media (max-width: 768px) {\n    // Медиазапрос для мобильных устройств\n    font-size: 20px; // Меньший размер шрифта для телефонов\n  }\n}\n\n.headerMiniTitle {\n  width: 50%;\n  margin: 50px auto;\n  text-align: justify;\n  margin-top: 15px;\n\n  @media (max-width: 768px) {\n    // Медиазапрос для мобильных устройств\n    width: 80%; // Увеличение ширины на мобильных устройствах\n    font-size: 16px; // Уменьшение размера шрифта, если необходимо\n  }\n}\n\n.headerContanier {\n  margin: 10px;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.сontanierText {\n  margin: 10px;\n  text-align: justify;\n  font-size: 18px;\n}\n\n// Общие стили для модальных окон\n.modal {\n  height: 100vh;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 2000;\n  transition: opacity 0.3s;\n\n  &.active {\n    opacity: 1;\n    pointer-events: all;\n  }\n\n  .modal_contanier {\n    position: relative;\n    max-height: 95vh;\n    min-width: 500px;\n    transform: scale(0.5);\n    transition: transform 0.4s, opacity 0.4s;\n    will-change: transform, opacity;\n    align-items: center;\n    justify-content: center;\n\n    &.active {\n      transform: scale(1);\n    }\n\n    @media (max-width: 768px) {\n      min-width: 50px;\n      max-height: 100vh;\n      max-width: 400px;\n      /* Исправьте значение для мобильных устройств */\n    }\n\n    .modal__content {\n      max-height: 95vh;\n      position: relative;\n      /* Максимальная высота модалки */\n      overflow: auto;\n      /* Прокрутка при переполнении */\n      padding: 20px;\n      border-radius: 12px;\n      background-color: white;\n\n      &::-webkit-scrollbar {\n        width: 8px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: rgba(0, 0, 0, 0.2);\n        border-radius: 10px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background-color: rgba(0, 0, 0, 0.1);\n      }\n\n      .view-container {\n        display: flex;\n        flex-direction: column;\n        background-color: #fff;\n        color: #333;\n        width: 120vh;\n        height: 100%;\n        padding: 0;\n        margin: 0;\n        border-radius: 0;\n        box-shadow: none;\n        overflow: auto;\n        .icon-container {\n          position: absolute;\n          top: 27px;\n          right: 60px;\n\n          .tooltip-text {\n            visibility: hidden;\n            background-color: rgba(40, 40, 40, 0.9); /* Более темный фон */\n            color: #fff;\n            overflow: auto;\n            max-height: 700px;\n            text-align: left; /* Прижимает текст к левому краю */\n            border-radius: 8px; /* Увеличенный радиус скругления */\n            padding: 10px 15px; /* Более крупные отступы для удобства */\n            position: absolute;\n            z-index: 1;\n            right: 0;\n            line-height: 1.6;\n            top: 30px;\n            width: 600px; /* Автоширина для текста */\n            word-wrap: break-word; /* Перенос длинных слов */\n            white-space: pre-line; /* Обработка \\n для новой строки */\n            opacity: 0;\n            transition: opacity 0.3s ease, visibility 0.3s ease;\n\n            /* Эффекты для красоты */\n            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Тень для объема */\n            border: 1px solid rgba(255, 255, 255, 0.2); /* Легкая граница */\n          }\n\n          &:hover .tooltip-text {\n            visibility: visible;\n            opacity: 1;\n          }\n        }\n\n        .file-contanier {\n          position: relative;\n\n          strong {\n            cursor: pointer;\n            /* Меняет курсор на указатель */\n            transition: color 0.3s ease;\n            /* Плавный переход цвета */\n            position: relative;\n\n            /* Для позиционирования стрелочки */\n            &::after {\n              content: \"▼\";\n              /* Стрелочка вниз */\n              display: inline-block;\n              margin-left: 8px;\n              /* Отступ между текстом и стрелочкой */\n              font-size: 12px;\n              /* Размер стрелочки */\n              transition: transform 0.3s ease;\n              /* Плавный переход стрелочки */\n            }\n\n            &.active::after {\n              transform: rotate(180deg);\n              /* Поворачивает стрелочку при открытом состоянии */\n            }\n\n            &:hover {\n              color: #0056b3;\n              /* Изменение цвета при наведении */\n            }\n          }\n\n          .file-legend {\n            display: none;\n            position: relative;\n            left: 0;\n            width: 30vw;\n            padding: 16px;\n            background-color: #f9f9f9;\n            border: 1px solid #ddd;\n            border-radius: 8px;\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n            z-index: 100;\n            transition: opacity 0.3s ease;\n\n            &.active {\n              display: flex;\n            }\n\n            .file-images {\n              display: flex;\n              flex-direction: row;\n              flex-wrap: wrap;\n              gap: 12px;\n              margin-top: 12px;\n\n              .image-container {\n                text-align: center;\n\n                .file-image {\n                  width: 100%;\n                  height: auto;\n                  cursor: pointer;\n                  border-radius: 8px;\n                  transition: transform 0.3s ease, opacity 0.3s ease;\n                  will-change: transform, opacity;\n\n                  &:hover {\n                    transform: scale(1.05);\n                    opacity: 0.9;\n                  }\n                }\n              }\n            }\n\n            .file-icons {\n              list-style-type: none;\n              padding: 0;\n              margin: 0;\n\n              .file-item {\n                display: flex;\n                align-items: center;\n                margin-bottom: 8px;\n                cursor: pointer;\n                transition: transform 0.3s ease;\n\n                &:hover {\n                  transform: scale(1.05);\n                }\n\n                .file-icon {\n                  width: 24px;\n                  height: 24px;\n                  margin-right: 12px;\n                }\n\n                .file-name {\n                  margin: 0;\n                  font-size: 14px;\n                  color: #555;\n                  max-width: calc(100% - 40px);\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                  white-space: nowrap;\n                  cursor: pointer;\n                }\n              }\n            }\n          }\n        }\n\n        .details {\n          display: flex;\n          flex-wrap: wrap;\n          justify-content: space-between;\n\n          .column {\n            flex: 0 0 48%;\n            margin: 0;\n          }\n\n          .content {\n            margin: 0;\n            display: flex;\n            width: 30vw;\n\n            .text-container {\n              overflow: hidden;\n              white-space: nowrap;\n              margin-left: auto;\n              width: 100%;\n              text-overflow: ellipsis;\n            }\n\n            .text-container:hover .full-text {\n              display: block;\n            }\n\n            .full-text {\n              display: none;\n              position: absolute;\n              border-radius: 8px;\n              white-space: normal;\n              font-size: 18px;\n              background: #fff;\n              border: 1px solid #ccc;\n              padding: 10px;\n              z-index: 4000;\n              max-width: 500px;\n            }\n          }\n        }\n\n        .chat-container {\n          height: 450px;\n        }\n\n        h2 {\n          color: $primary-color;\n          margin-bottom: 5px;\n        }\n\n        .additional-content {\n          padding: 10px;\n          border-top: 1px solid #ccc;\n          margin-top: 20px;\n\n          > p {\n            color: darken(#333, 20%);\n          }\n        }\n\n        .details-actions-container {\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n\n  .modal__close {\n    transform: scale(0.5);\n    cursor: pointer;\n    position: absolute;\n    top: 10px;\n    /* Положение кнопки закрытия */\n    right: 10px;\n    padding: 5px;\n    border-radius: 200px;\n    /* Положение кнопки закрытия */\n    z-index: 100;\n    transition: transform 0.3s;\n\n    &:hover {\n      transform: scale(0.6);\n    }\n  }\n\n  @media (max-width: 768px) {\n    /* Исправьте значение для мобильных устройств */\n  }\n}\n\n// Общие стили для Navbar и NavLink\n.custom-navbar {\n  background-color: rgb(255, 255, 255);\n  margin-left: 1px;\n}\n\n.nav-link {\n  color: $primary-color;\n  border-radius: 8px;\n\n  &:hover {\n    border-radius: 8px;\n    color: #ffffff;\n    background-color: $primary-color;\n  }\n}\n\n// Общие стили для кнопок функций\n.button-func {\n  margin: 5px;\n  background-color: $primary-color;\n  color: rgb(255, 255, 255);\n  border: 2px solid $primary-color;\n  width: 100px;\n  height: 40px;\n  cursor: pointer;\n  text-align: center;\n  font-size: 18px;\n  border-radius: 8px;\n  transition: background-color 0.3s ease;\n\n  &:hover {\n    background-color: rgb(255, 255, 255);\n    color: $primary-color;\n    border-radius: 8px;\n    border: 2px solid $primary-color;\n  }\n}\n\n// Общие стили для логотипов\n.logo {\n  width: 40px;\n  height: 40px;\n  margin: 10px;\n}\n\n.logo-neon {\n  display: inline-block;\n  position: relative;\n  padding: 3px;\n  width: 40px;\n  overflow: visible; // Предотвращение обрезания\n  height: 40px;\n\n  .path {\n    fill: none; // Удаление заливки\n    stroke-width: 0.5; // Толщина контура\n    stroke-linecap: round; // Закругление концов линий\n    stroke-linejoin: round; // Закругление соединений линий\n    stroke: #b6e33e; // Основной цвет контура\n    filter: drop-shadow(0 0 5px rgba(182, 227, 62, 0.5))\n      drop-shadow(0 0 10px rgba(182, 227, 62, 0.5));\n    transition: filter 0.3s ease-in-out;\n    animation: neon-glow 1.5s ease-in-out infinite, blink 7s linear infinite; // Анимация по умолчанию\n\n    &:nth-child(1) {\n      // Первый элемент\n      stroke: #b6e33e; // Основной цвет контура\n      animation: neon-glow 1.5s ease-in-out infinite,\n        blink-general 8s linear infinite;\n    }\n\n    &:nth-child(2) {\n      // Второй элемент\n      stroke: #b6e33e; // Основной цвет контура\n      animation: neon-glow 2s ease-in-out infinite,\n        blink-general 9s linear infinite;\n    }\n\n    &:nth-child(3) {\n      // Третий элемент\n      stroke: #b6e33e; // Основной цвет контура\n      animation: neon-glow 1.8s ease-in-out infinite,\n        blink-general 7s linear infinite;\n    }\n\n    &:nth-child(4) {\n      // Четвертый элемент\n      stroke: #b6e33e; // Основной цвет контура\n      animation: neon-glow 1.6s ease-in-out infinite,\n        blink-general 6s linear infinite;\n    }\n\n    &:last-child {\n      // Последний элемент\n      stroke: rgb(77, 128, 0); // Основной цвет контура для последнего элемента\n      animation: neon-glow-alt 2s ease-in-out infinite,\n        blink-last 7.5s linear infinite; // Другая анимация для последнего\n    }\n  }\n}\n\n// Анимация свечения\n@keyframes neon-glow {\n  0%,\n  100% {\n    filter: drop-shadow(0 0 1px rgba(182, 227, 62, 0.3))\n      drop-shadow(0 0 2px rgba(182, 227, 62, 0.3));\n  }\n\n  25% {\n    filter: drop-shadow(0 0 1px rgba(182, 227, 62, 0.5))\n      drop-shadow(0 0 2px rgba(182, 227, 62, 0.5));\n  }\n\n  50% {\n    filter: drop-shadow(0 0 1px rgba(182, 227, 62, 0.7))\n      drop-shadow(0 0 2px rgba(182, 227, 62, 0.7));\n  }\n\n  75% {\n    filter: drop-shadow(0 0 1px rgba(182, 227, 62, 0.4))\n      drop-shadow(0 0 2px rgba(182, 227, 62, 0.4));\n  }\n}\n\n// Альтернативная анимация свечения для последнего элемента\n@keyframes neon-glow-alt {\n  0%,\n  100% {\n    filter: drop-shadow(0 0 1px rgba(92, 255, 51, 0.3))\n      drop-shadow(0 0 2px rgba(92, 255, 51, 0.3));\n  }\n\n  25% {\n    filter: drop-shadow(0 0 1px rgba(92, 255, 51, 0.5))\n      drop-shadow(0 0 2px rgba(92, 255, 51, 0.5));\n  }\n\n  50% {\n    filter: drop-shadow(0 0 1px rgba(92, 255, 51, 0.7))\n      drop-shadow(0 0 2px rgba(92, 255, 51, 0.7));\n  }\n\n  75% {\n    filter: drop-shadow(0 0 1px rgba(92, 255, 51, 0.4))\n      drop-shadow(0 0 2px rgba(92, 255, 51, 0.4));\n  }\n}\n\n// Новая анимация моргания\n@keyframes blink-general {\n  0%,\n  93%,\n  100% {\n    stroke: #b6e33e; // Основной цвет контура\n  }\n\n  99% {\n    stroke: #546621; // Черный цвет контура\n  }\n\n  98% {\n    stroke: #b6e33e; // Основной цвет контура\n  }\n\n  97% {\n    stroke: #708b26; // Черный цвет контура\n  }\n\n  96% {\n    stroke: #b6e33e; // Основной цвет контура\n  }\n\n  95% {\n    stroke: #546621; // Черный цвет контура\n  }\n\n  94% {\n    stroke: #b6e33e; // Основной цвет контура\n  }\n}\n\n// Анимация моргания для последнего элемента\n@keyframes blink-last {\n  0%,\n  93%,\n  100% {\n    stroke: rgb(77, 128, 0); // Основной цвет контура для последнего элемента\n  }\n\n  99% {\n    stroke: rgb(38, 63, 0); // Черный цвет контура\n  }\n\n  98% {\n    stroke: rgb(77, 128, 0); // Основной цвет контура для последнего элемента\n  }\n\n  97% {\n    stroke: rgb(38, 63, 0); // Черный цвет контура\n  }\n\n  96% {\n    stroke: rgb(77, 128, 0); // Основной цвет контура для последнего элемента\n  }\n\n  95% {\n    stroke: rgb(38, 63, 0); // Черный цвет контура\n  }\n\n  94% {\n    stroke: rgb(77, 128, 0); // Основной цвет контура для последнего элемента\n  }\n}\n\n.date-picker-container {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n}\n\n.date-picker-label {\n  margin-right: 10px;\n  /* Отступ справа от метки */\n}\n\n.toggle-button {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .toggle-button {\n    display: flex;\n    background-color: white;\n    padding: 10px 20px;\n    font-size: 16px;\n    cursor: pointer;\n    /* Отключение выделения текста при клике */\n    display: flex;\n    align-items: center;\n  }\n\n  .arrow {\n    display: inline-block;\n    margin-left: 8px;\n    transition: transform 0.3s ease;\n    /* Анимация вращения */\n  }\n\n  .arrow.open {\n    transform: rotate(180deg);\n    /* Вращение на 180 градусов */\n  }\n\n  .checkbox-container {\n    margin: 10px;\n  }\n\n  .date-picker-container {\n    display: contents;\n    background-color: white;\n    z-index: 1000;\n\n    .date-picker-label {\n      margin: 10px;\n    }\n\n    /* На мобильных устройствах контейнеры занимают всю ширину */\n    .input {\n      margin: 10px;\n    }\n  }\n\n  .date-picker-container {\n    display: none;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .date-picker-container.open {\n    display: flex;\n  }\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  font-size: 16px;\n  color: #333;\n  position: relative;\n\n  // Скрываем стандартный чекбокс\n  .checkbox-input {\n    opacity: 0;\n    position: absolute;\n    cursor: pointer;\n    z-index: 1; // Убедитесь, что стандартный чекбокс находится ниже кастомного\n\n    // Стили для отключенного состояния чекбокса\n    &:disabled {\n      cursor: not-allowed;\n    }\n  }\n\n  // Кастомный чекбокс\n  .checkmark {\n    width: 24px; // Размер кастомного чекбокса\n    height: 24px;\n    border: 1px solid #ccc; // Цвет обводки по умолчанию\n    border-radius: 50%; // Круглая форма\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.3s ease, border-color 0.3s ease,\n      box-shadow 0.3s ease; // Плавные переходы\n    margin-right: 12px; // Расстояние между чекбоксом и текстом\n\n    // Галочка\n    &::after {\n      content: \"\";\n      position: absolute;\n      display: none; // Галочка скрыта по умолчанию\n      width: 8px;\n      height: 16px;\n      border: solid #fff; // Цвет галочки\n      border-width: 0 2px 2px 0;\n      transform: rotate(45deg);\n      top: 40%;\n      left: 50%;\n      transform: translate(-50%, -50%) rotate(45deg); // Центрирование и поворот галочки\n    }\n  }\n\n  // Когда чекбокс выбран\n  .checkbox-input:checked + .checkmark {\n    background-color: #007bff; // Цвет фона при выборе\n    border-color: #007bff; // Цвет обводки при выборе\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2); // Тень для акцентирования\n\n    &::after {\n      display: block; // Показываем галочку при выборе\n    }\n  }\n\n  // Эффект при наведении\n  &:hover .checkmark {\n    background-color: #e6e6e6; // Цвет фона при наведении\n    border-color: #999; // Цвет обводки при наведении\n  }\n\n  // Стили для отключенного состояния чекбокса\n  .checkbox-input:disabled + .checkmark {\n    background-color: #f2f2f2; // Цвет фона для отключенного состояния\n    border-color: #d9d9d9; // Цвет обводки для отключенного состояния\n    cursor: not-allowed; // Меняем курсор на запрещающий\n  }\n\n  // Стили для текста\n  .checkbox-label {\n    font-size: 16px; // Размер шрифта текста\n    color: #333; // Цвет текста\n\n    // Отключенный текст\n    .checkbox-input:disabled + .checkmark + & {\n      color: #b3b3b3; // Цвет текста для отключенного состояния\n      cursor: not-allowed;\n    }\n  }\n}\n\n.chat-container {\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  background-color: #f7f7f7;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  position: relative;\n\n  .chat {\n    flex: 1;\n    overflow-y: auto;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    h4 {\n      font-size: 22px;\n      margin-bottom: 15px;\n      margin: 10px;\n      color: #333;\n      font-weight: 600;\n    }\n\n    .message {\n      border-radius: 10px;\n      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\n      margin: 10px 0;\n      padding: 12px 16px;\n      display: flex;\n      align-items: flex-start;\n      background-color: #fff;\n      position: relative;\n      transition: background-color 0.3s ease, transform 0.3s ease;\n      will-change: background-color, transform;\n      word-break: break-word;\n      overflow-wrap: break-word;\n\n      &.highlighted {\n        background-color: rgba(255, 0, 0, 0.1);\n        animation: chatpulse 3s infinite;\n      }\n\n      @keyframes chatpulse {\n        0% {\n          background-color: rgba(160, 0, 0, 0.1);\n        }\n\n        50% {\n          background-color: rgba(255, 0, 0, 0.2);\n        }\n\n        90% {\n          background-color: rgba(255, 0, 0, 0.1);\n        }\n      }\n\n      .chat-avatar {\n        width: 50px;\n        height: 50px;\n        margin-right: 12px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n\n      .chat-content {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n\n        span {\n          margin: 0;\n          font-size: 18px;\n          color: #444;\n        }\n\n        strong {\n          margin: 0;\n          font-size: 18px;\n          color: #000;\n        }\n\n        .message-date,\n        .message-category {\n          margin-left: auto;\n          color: #999;\n          font-size: 14px;\n        }\n\n        .file-images {\n          display: flex;\n          flex-direction: row;\n          flex-wrap: wrap;\n          gap: 12px;\n          margin-top: 12px;\n\n          .image-container {\n            flex: 1 1 calc(33% - 12px);\n            max-width: calc(33% - 12px);\n            text-align: center;\n\n            .file-image {\n              width: 100%;\n              height: auto;\n              cursor: pointer;\n              border-radius: 8px;\n              transition: transform 0.3s ease, opacity 0.3s ease;\n              will-change: transform, opacity;\n\n              &:hover {\n                transform: scale(1.05);\n                opacity: 0.9;\n              }\n            }\n          }\n        }\n\n        .file-icons {\n          list-style-type: none;\n          padding: 0;\n          margin: 0;\n\n          .file-item {\n            display: flex;\n            align-items: center;\n            margin-bottom: 8px;\n            cursor: pointer;\n            transition: transform 0.3s ease;\n\n            &:hover {\n              transform: scale(1.05);\n            }\n\n            .file-icon {\n              width: 24px;\n              height: 24px;\n              margin-right: 12px;\n            }\n\n            .file-name {\n              margin: 0;\n              font-size: 14px;\n              color: #555;\n              max-width: calc(100% - 40px);\n              overflow: hidden;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              cursor: pointer;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .edit-icon {\n    margin-left: auto;\n    color: #888;\n    font-size: 16px;\n    cursor: pointer;\n    transition: color 0.3s ease, transform 0.3s ease;\n\n    &:hover {\n      color: #333;\n      transform: scale(1.1);\n    }\n  }\n\n  .comment-input {\n    padding: 10px;\n    margin-top: auto;\n  }\n}\n\n/* Медиазапросы для мобильных устройств */\n@media (max-width: 768px) {\n  .chat-content {\n    width: 85% !important;\n  }\n\n  .chat-avatar {\n    width: 40px !important;\n    height: 40px !important;\n  }\n}\n\n.loading-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  gap: 10px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid $primary-color;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.header {\n  padding: 5px;\n  height: 28px;\n  background-color: $primary-color; // Используйте переменную цвета из вашего файла стилей\n  color: white;\n  align-items: center;\n  display: flex;\n  border-radius: 8px;\n\n  p {\n    margin: 0;\n    font-size: 16px;\n    font-weight: bold;\n  }\n}\n\n// Медиа-запросы для мобильных устройств\n@media (max-width: 768px) {\n  body {\n    font-size: 14px; // Уменьшаем размер шрифта\n  }\n\n  .grid-view-container {\n    display: block; // Изменяем flex на block, чтобы элементы располагались друг под другом\n\n    .grid-container,\n    .view-container {\n      width: 100%; // Контейнеры занимают всю ширину\n    }\n  }\n\n  .button-func,\n  button {\n    width: auto; // Автоматическая ширина для удобства на мобильных\n    padding: 8px 16px; // Уменьшаем размеры кнопок\n  }\n\n  .modal__content {\n    min-width: 300px; // Уменьшаем минимальную ширину модальных окон\n    transform: scale(1); // Отключаем уменьшение масштаба\n  }\n\n  .search-container {\n    flex-direction: column; // Элементы в поисковой панели располагаются вертикально\n    align-items: stretch;\n  }\n}\n\n.container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(600px, 1fr));\n  /* Создаем грид с колонками шириной 300px (минимум) и автоматически расширяемыми */\n  grid-gap: 20px;\n  /* Отступ между элементами */\n  justify-content: center;\n  /* Центрируем контейнеры по горизонтали */\n}\n\n.tracking-container {\n  height: 85vh;\n  overflow: auto;\n  margin: 10px 20px;\n  padding: 0px 10px;\n  box-sizing: border-box;\n  background-color: rgb(255, 255, 255);\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n@media (max-width: 768px) {\n  .container {\n    grid-template-columns: 1fr;\n    /* На мобильных устройствах контейнеры занимают всю ширину */\n  }\n}\n\n.notification-icon-container {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 1299;\n\n  .notification-icon {\n    cursor: pointer;\n    position: relative;\n    z-index: 2;\n\n    .icon {\n      border-radius: 50%;\n      width: 40px;\n      height: 40px;\n      display: flex;\n      background-color: #ffffff;\n      justify-content: center;\n      align-items: center;\n      transition: transform 0.3s;\n\n      svg {\n        fill: white;\n      }\n\n      &.blink {\n        animation: blinkAnimation 1s infinite;\n      }\n    }\n\n    @keyframes blinkAnimation {\n      0% {\n        box-shadow: 0 0 0px $secondary-color;\n      }\n\n      50% {\n        box-shadow: 0 0 20px $secondary-color;\n      }\n\n      100% {\n        box-shadow: 0 0 0px $secondary-color;\n      }\n    }\n\n    /* Счетчик для персональных уведомлений (слева от иконки) */\n    .personal-count {\n      background-color: $primary-color;\n      color: white;\n      font-weight: bold;\n      border-radius: 50%;\n      width: 24px;\n      height: 24px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: absolute;\n      bottom: -8px;\n      left: -8px;\n      /* Слева от иконки */\n      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\n    }\n\n    /* Счетчик для системных уведомлений (справа от иконки) */\n    .system-count {\n      background-color: #ff6347;\n      color: white;\n      font-weight: bold;\n      border-radius: 50%;\n      width: 24px;\n      height: 24px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: absolute;\n      bottom: -8px;\n      right: -8px;\n      /* Справа от иконки */\n      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\n    }\n\n    &:hover .icon svg {\n      transform: scale(1.1);\n    }\n  }\n\n  .notification-list {\n    position: fixed;\n    top: 0px;\n    right: -100%;\n    width: 30%;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(10px);\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);\n    padding: 20px;\n    overflow-y: auto;\n    transition: right 0.3s;\n\n    &.open {\n      right: 0;\n    }\n\n    .notification-tabs {\n      display: flex;\n      justify-content: space-around;\n      margin-bottom: 20px;\n\n      button {\n        flex-grow: 1;\n        padding: 12px 20px;\n        background-color: rgba(255, 255, 255, 0.2);\n        border: none;\n        color: white;\n        font-weight: bold;\n        border-radius: 8px;\n        cursor: pointer;\n        transition: background-color 0.3s;\n\n        &.active {\n          background-color: rgba(255, 255, 255, 0.6);\n          color: $primary-color;\n        }\n\n        &:hover {\n          background-color: rgba(255, 255, 255, 0.4);\n        }\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n\n    ul {\n      list-style: none;\n      padding: 0;\n\n      .notification-item {\n        background-color: rgba(255, 255, 255, 0.95);\n        border-radius: 12px;\n        margin-bottom: 15px;\n        cursor: pointer;\n        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);\n        transition: transform 0.2s, box-shadow 0.2s;\n\n        &:hover {\n          transform: translateY(-5px);\n          box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.3);\n        }\n\n        &.unread {\n          font-weight: bold;\n          background-color: rgba(255, 243, 205, 0.9);\n        }\n\n        .notification-content {\n          display: grid;\n          grid-template-areas:\n            \"header header header\"\n            \"message delete delete\";\n          grid-template-columns: 1fr auto;\n          gap: 5px;\n          border-radius: 12px;\n          margin-bottom: 15px;\n          padding: 15px;\n          cursor: pointer;\n          box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);\n          transition: transform 0.2s, box-shadow 0.2s;\n        }\n\n        .notification-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          grid-area: header;\n        }\n\n        .task-id {\n          font-weight: bold;\n          color: #110092;\n          font-size: 16px;\n          text-decoration: underline;\n        }\n\n        .notification-date {\n          color: #0000005a;\n          font-size: 12px;\n          font-weight: bold;\n        }\n\n        .message {\n          grid-area: message;\n          width: 100%;\n          overflow-wrap: break-word;\n          color: #333;\n          font-size: 16px;\n        }\n\n        .delete-button {\n          grid-area: delete;\n          background: none;\n          border: none;\n          width: 40px;\n          height: 40px;\n          color: #630000;\n          cursor: pointer;\n          font-size: 20px;\n          font-weight: bold;\n          transition: color 0.3s;\n          align-self: center;\n          /* Center vertically in its grid cell */\n        }\n\n        .delete-button:hover {\n          color: #ff0000;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 480px) {\n    right: 10px;\n    bottom: 10px;\n\n    .notification-icon .icon {\n      width: 35px;\n      height: 35px;\n    }\n\n    .personal-count,\n    .system-count {\n      width: 20px;\n      height: 20px;\n      font-size: 12px;\n    }\n\n    .notification-list {\n      width: 100%;\n      padding: 10px;\n\n      .notification-tabs button {\n        padding: 8px;\n        font-size: 14px;\n      }\n\n      ul .notification-item {\n        font-size: 12px;\n      }\n\n      .notification-content .message {\n        font-size: 12px;\n      }\n\n      .delete-button {\n        font-size: 18px;\n      }\n    }\n  }\n}\n\n.notification {\n  position: fixed;\n  top: 0px;\n  right: 20px;\n  padding: 15px;\n  background: #ffffff;\n  opacity: 0;\n  font-weight: bold;\n  transform: translateY(0);\n  transition: opacity 0.3s, transform 0.3s;\n  z-index: 1100;\n  border-radius: 8px;\n  font-family: Arial, sans-serif;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  background-color: #fff;\n  border: 1px solid #000000;\n  /* Красная рамка */\n  overflow: hidden;\n\n  &.success {\n    color: #4caf50;\n    /* Зеленый цвет для успешных уведомлений */\n    border-color: #4caf50;\n\n    /* Зеленая рамка */\n    &::after {\n      background-color: #4caf50;\n      /* Красная полоска */\n    }\n  }\n\n  &.error {\n    color: #f44336;\n    /* Красный цвет для уведомлений об ошибках */\n    border-color: #f44336;\n\n    /* Красная рамка */\n    &::after {\n      background-color: #f44336;\n      /* Красная полоска */\n    }\n  }\n\n  &.animate-in-out {\n    animation: fadeInOut 2s ease-in-out;\n  }\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 5px;\n    background-color: rgba(0, 0, 0, 0.1);\n    /* Полоска снизу */\n    animation: slideOut 2s linear;\n  }\n}\n\n@keyframes fadeInOut {\n  0%,\n  100% {\n    opacity: 0;\n    transform: translateY(0);\n  }\n\n  20%,\n  80% {\n    opacity: 1;\n    transform: translateY(50%);\n  }\n}\n\n@keyframes slideOut {\n  0% {\n    width: 100%;\n  }\n\n  100% {\n    width: 0;\n  }\n}\n\n// Define variables for colors and dimensions if needed\n$avatar-width: 100px;\n$avatar-height: 100px;\n$avatar-border-radius: 50%;\n\n.user-container-info {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.user-info {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 20px;\n  background-color: rgba(255, 255, 255, 0.8);\n  margin: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 48%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n\n  h2 {\n    font-size: 20px;\n    margin-bottom: 10px;\n  }\n\n  ul {\n    list-style: none;\n    padding: 0;\n  }\n\n  ul li {\n    margin-bottom: 5px;\n\n    strong {\n      margin-right: 5px;\n    }\n  }\n}\n\n.avatar {\n  position: relative;\n  width: $avatar-width;\n  height: $avatar-height;\n  margin: auto 20px;\n  border-radius: $avatar-border-radius;\n  overflow: hidden;\n  cursor: pointer;\n\n  .avatar-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &:hover {\n    .avatar-hover {\n      display: flex;\n    }\n  }\n}\n\n.avatar-hover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: $avatar-width;\n  height: $avatar-height;\n  background: rgba(0, 0, 0, 0.5);\n  display: none;\n  align-items: center; // Center vertically\n  justify-content: center; // Center horizontally\n  color: white;\n  font-size: 16px;\n  border-radius: $avatar-border-radius;\n\n  label {\n    cursor: pointer;\n  }\n}\n\n.custom-file-upload {\n  cursor: pointer;\n  text-align: center;\n}\n\n#file-upload {\n  display: none;\n}\n\n// Media query for responsiveness\n@media (max-width: 768px) {\n  .user-info {\n    width: 100%;\n    margin: 10px 0;\n  }\n}\n\n.depart-workload {\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n\n  .dropdown {\n    position: relative;\n    display: inline-block;\n\n    .dropdown-button {\n      background-color: white;\n      color: $primary-color;\n      padding: 5px;\n      height: 30px;\n      border: 1px solid $primary-color;\n      cursor: pointer;\n      font-size: 1rem;\n      border-radius: 8px;\n      position: relative;\n      white-space: nowrap;\n      transition: background-color 0.3s, color 0.3s;\n      display: flex;\n      align-items: center;\n\n      .button-text {\n        flex: 1;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      &.selected {\n        background-color: $primary-color;\n        color: #fff;\n\n        .clear-selection {\n          cursor: pointer;\n          font-size: 1rem;\n          margin-left: 5px;\n          color: #fff;\n\n          &:hover {\n            color: $primary-color;\n            border-radius: 8px;\n            background-color: #fff;\n          }\n        }\n      }\n\n      .clear-selection {\n        margin-left: auto;\n        cursor: pointer;\n        font-size: 1rem;\n        color: $primary-color;\n\n        &:hover {\n          color: $secondary-color;\n        }\n      }\n    }\n\n    .dropdown-content {\n      display: block;\n      position: absolute;\n      background-color: #f9f9f9;\n      border: 1px solid $primary-color;\n      border-radius: 8px;\n      padding: 5px;\n      max-height: 200px;\n      overflow-y: auto;\n      z-index: 3;\n      width: auto;\n      min-width: 150px;\n      margin-top: 0.5rem;\n      left: 0;\n\n      .item {\n        border-bottom: 1px solid #ddd;\n        border-radius: 8px;\n        padding: 5px;\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        .item-name {\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        &.selected {\n          background-color: $primary-color;\n          color: white;\n        }\n      }\n    }\n  }\n}\n\n.year-month-selector {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n\n  &__select {\n    padding: 5px;\n    font-size: 16px;\n    height: 100%;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n    color: #333;\n    cursor: pointer;\n\n    &:hover {\n      border-color: #888;\n    }\n\n    &:focus {\n      outline: none;\n      border-color: #555;\n    }\n  }\n}\n\n$link-shadow-color: rgba(0, 0, 0, 0.15);\n$hover-color: #0f7996;\n$error-color: #d9534f;\n\n.link-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: Arial, sans-serif;\n  padding: 20px;\n  background-color: $background-color;\n  width: 98%;\n  border-radius: 16px;\n  box-sizing: border-box;\n  margin: 10px;\n  height: 80vh;\n\n  h1 {\n    color: #333;\n    margin-bottom: 20px;\n    padding: 10px;\n    border-radius: 15px;\n    background-color: #fff;\n  }\n\n  .link-content {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    gap: 20px;\n  }\n\n  .link-block {\n    display: flex;\n    flex: 1;\n    gap: 20px;\n    height: 85%;\n    width: 100%;\n    /* Ширина блока в 100%, чтобы контролировать ширину колонок */\n\n    .project-def {\n      padding: 10px;\n      background-color: $primary-color;\n      border-radius: 15px;\n      transition: background-color 0.2s ease;\n      overflow-y: auto;\n      /* Прокрутка для списка сотрудников */\n      max-height: 100%;\n      /* Ограничение высоты блока */\n      width: 100%;\n\n      /* Занимает всю доступную ширину в .link-block */\n      h2,\n      h3 {\n        border-radius: 5px;\n        color: #333;\n        font-size: 16px;\n        margin-bottom: 10px;\n        text-align: center;\n        position: sticky;\n        top: 0;\n        background-color: #ffffff;\n        padding: 10px 0;\n        z-index: 1;\n        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n      }\n    }\n\n    .project-wrapper {\n      display: flex;\n      flex-direction: row;\n      /* Колонки будут располагаться горизонтально */\n      flex: 1;\n      gap: 20px;\n      overflow-x: auto;\n      /* Горизонтальная прокрутка для блоков проектов */\n      padding-bottom: 10px;\n\n      /* Чтобы блоки .project масштабировались автоматически */\n      .project {\n        display: flex;\n        flex-direction: column;\n        background-color: #ffffff;\n        border-radius: 15px;\n        padding: 10px;\n        box-shadow: 0 2px 5px rgba(16, 112, 50, 0.3);\n        overflow-y: auto;\n        /* Вертикальная прокрутка внутри блока проекта */\n        overflow-x: hidden;\n        /* Убираем горизонтальную прокрутку */\n        flex: 1 0 250px;\n        /* Гибкая ширина блока проекта */\n        max-height: 100%;\n\n        h3 {\n          color: #333;\n          font-size: 16px;\n          margin-bottom: 10px;\n          border-radius: 5px;\n          text-align: center;\n          position: sticky;\n          top: 0;\n          background-color: #ffffff;\n          padding: 10px 0;\n          z-index: 1;\n          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n        }\n\n        .category-new {\n          background-color: #f9f9f9;\n          color: #333;\n          margin-bottom: 10px;\n          padding: 10px;\n          border-radius: 5px;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n\n          button {\n            background: none;\n            border: none;\n            color: $error-color;\n            font-size: 16px;\n            cursor: pointer;\n            transition: color 0.2s ease;\n\n            &:hover {\n              color: darken($error-color, 10%);\n            }\n          }\n        }\n      }\n    }\n\n    /* Медиазапрос для мобильных устройств */\n    @media (max-width: 600px) {\n      .project-def,\n      .project-wrapper {\n        width: 40%;\n        /* Ширина колонок на мобильных устройствах */\n      }\n    }\n\n    /* Ширина колонок для ПК */\n    @media (min-width: 601px) {\n      .project-def,\n      .project-wrapper {\n        width: 20%;\n        /* Ширина колонок на ПК */\n      }\n    }\n  }\n\n  .category,\n  .category-new {\n    padding: 10px;\n    margin: 5px 0;\n    background-color: #ffffff;\n    border-radius: 5px;\n    cursor: grab;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    font-size: 14px;\n    text-align: center;\n    user-select: none;\n    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);\n\n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 0 8px $link-shadow-color;\n    }\n  }\n}\n\n.dragged-element {\n  display: none;\n  pointer-events: none;\n  background-color: rgba(255, 255, 255, 0.9);\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  z-index: 1000;\n  transform: translate(-50%, -50%);\n}\n\n/* Медиазапрос для мобильных устройств */\n@media (max-width: 600px) {\n  .dragged-element {\n    position: absolute;\n    display: flex;\n    padding: 8px;\n    font-size: 16px;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);\n    background-color: rgba(255, 255, 255, 0.95);\n  }\n}\n\n.accordion {\n  margin: 20px;\n\n  .accordion-panel {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    .accordion-header {\n      cursor: pointer;\n      padding: 15px 20px;\n      background-color: #fafafa;\n      border-bottom: 1px solid #eee;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      transition: background-color 0.3s ease;\n\n      &.active {\n        background-color: #e0e0e0;\n      }\n\n      .header-content {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n\n        .colum {\n          flex: 1;\n          margin: 0 10px;\n          white-space: nowrap;\n          overflow: hidden;\n          font-size: 18px;\n          text-overflow: ellipsis;\n        }\n      }\n\n      .chevron {\n        width: 16px;\n        height: 16px;\n        transition: transform 0.3s ease;\n\n        &.rotate {\n          transform: rotate(180deg);\n        }\n      }\n    }\n\n    .accordion-content {\n      padding: 15px 20px;\n      background-color: #fff;\n\n      ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n\n        li {\n          display: flex;\n          align-items: center;\n          padding: 10px 0;\n          border-bottom: 1px solid #eee;\n          transition: background-color 0.3s ease;\n          justify-content: space-between;\n\n          &:last-child {\n            border-bottom: none;\n          }\n\n          &:hover {\n            background-color: #f9f9f9;\n          }\n\n          span {\n            margin: 0 10px;\n            color: #666;\n            font-size: 16px;\n          }\n\n          a {\n            text-decoration: none;\n            color: #007bff;\n            font-weight: 500;\n            margin-right: 10px;\n            transition: color 0.3s ease;\n\n            &:hover {\n              color: #0056b3;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.attendance {\n  padding: 10px;\n  margin: 10px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: auto;\n\n  .table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: #fff;\n    border-radius: 8px;\n    overflow: hidden;\n\n    th,\n    td {\n      padding: 7px 2px;\n      text-align: center;\n      font-size: 14px;\n      border: 1px solid #e0e0e0;\n\n      &.weekend {\n        background-color: #fcbbbb; // Цвет для выделения выходных\n        color: #710c0c; // Цвет текста для выделения выходных\n      }\n\n      select {\n        width: 100%;\n        padding: 5px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        background-color: #fff;\n        font-size: 14px;\n        cursor: pointer;\n        transition: all 0.3s ease;\n\n        &:focus {\n          outline: none;\n          border-color: #007bff;\n        }\n      }\n    }\n\n    thead {\n      background-color: $primary-color;\n      color: #fff;\n      font-weight: bold;\n    }\n\n    tbody {\n      tr {\n        &:nth-child(even) {\n          background-color: #f2f2f2;\n        }\n\n        &:hover {\n          background-color: #e0e0e0;\n        }\n\n        td {\n          &:first-child {\n            text-align: left;\n            font-weight: bold;\n            white-space: nowrap;\n          }\n\n          .input {\n            height: auto;\n            width: 40px;\n            padding: 2px;\n            border: 0;\n\n            &.status-vacation {\n              background-color: yellow;\n            }\n\n            &.status-sick {\n              background-color: red;\n            }\n\n            &.status-business-trip {\n              background-color: blue;\n            }\n\n            &.status-off {\n              background-color: grey;\n            }\n\n            &.status-present {\n              background-color: green;\n            }\n          }\n\n          &.weekend {\n            background-color: #ffebee; // Цвет для выделения выходных\n            color: #d32f2f; // Цвет текста для выделения выходных\n          }\n        }\n      }\n    }\n  }\n}\n\n.legend {\n  background-color: #fff;\n  border-radius: 8px;\n  width: auto;\n  margin: 10px;\n  display: inline-block;\n}\n\n.legend p {\n  padding: 5px;\n}\n\n.legend span {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n  text-align: center;\n  color: white;\n  font-weight: bold;\n\n  &.status-vacation {\n    background-color: yellow;\n  }\n\n  &.status-sick {\n    background-color: red;\n  }\n\n  &.status-business-trip {\n    background-color: blue;\n  }\n\n  &.status-off {\n    background-color: grey;\n  }\n\n  &.status-present {\n    background-color: green;\n  }\n}\n\n// VacationSchedule.module.scss\n\n.vacation-schedule {\n  margin: 10px;\n  border-radius: 8px;\n  padding: 10px;\n  background-color: #ffffff;\n\n  h2 {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n\n    th,\n    td {\n      border: 1px solid #ddd;\n      padding: 8px;\n      background-color: #f0f0f0;\n      text-align: center;\n    }\n\n    th {\n      background-color: #f2f2f2;\n    }\n  }\n}\n\n.year-selector {\n  display: flex;\n  gap: 10px;\n  padding: 5px;\n\n  border-radius: 8px;\n  background-color: #fff;\n  margin-bottom: 20px;\n\n  .p {\n    align-content: center;\n  }\n\n  .year {\n    padding: 5px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n    color: #333;\n    cursor: pointer;\n\n    &:hover {\n      border-color: #888;\n    }\n\n    &:focus {\n      outline: none;\n      border-color: #555;\n    }\n  }\n}\n\n// ServiceList.module.scss\n\n.service-category {\n  p {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 0.8em;\n    color: #333;\n    /* Темный цвет для заголовка */\n  }\n\n  .service-category-header {\n    display: grid;\n    grid-template-columns: 1fr 100px 100px 50px;\n    /* Перераспределение ширины */\n    gap: 10px;\n    align-items: center;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 8px;\n    margin-bottom: 15px;\n\n    .service-category-header-item {\n      font-weight: 600;\n      color: #555;\n      /* Мягкий серый цвет для заголовков */\n      font-size: 14px;\n    }\n  }\n\n  .service-category-item {\n    display: grid;\n    grid-template-columns: 1fr 100px 100px 50px;\n    /* Перераспределение ширины */\n    gap: 10px;\n    align-items: center;\n    margin-bottom: 8px;\n    padding: 8px 10px;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    background-color: #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);\n    }\n\n    .service-category-content {\n      display: flex;\n      align-items: center;\n      color: #444;\n      /* Насыщенный серый для текста */\n      font-size: 14px;\n    }\n\n    .service-category-actions {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .service-category-buttons {\n      display: flex;\n      gap: 4px;\n      /* Уменьшено расстояние между кнопками */\n      justify-content: center;\n      align-items: center;\n      max-width: 50px;\n      /* Максимальная ширина для контейнера */\n    }\n\n    .icon-button {\n      background: none;\n      border: none;\n      cursor: pointer;\n      font-size: 18px;\n      color: #666;\n      padding: 2px;\n      transition: color 0.2s ease, transform 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .icon-button:hover {\n      color: #0056b3;\n      transform: scale(1.1);\n    }\n\n    .delete-button i {\n      color: #ff4d4d;\n      /* Красный для удаления */\n    }\n\n    .add-service-button i {\n      color: #007bff;\n      /* Синий для добавления */\n      font-size: 24px;\n      /* Увеличенный размер иконки */\n    }\n  }\n}\n\n.clip-icon {\n  cursor: pointer;\n  margin: auto 10px 10px 10px;\n  width: 24px;\n  background-color: white;\n  height: 24px;\n  border-radius: 50px;\n\n  &:hover {\n    color: white;\n    background-color: $primary-color;\n    transition: 0.5s ease;\n  }\n}\n\n.enots {\n  padding: 20px;\n  margin: 20px;\n  background-color: #f4f4f9;\n  border-radius: 10px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);\n  overflow: auto;\n\n  .table {\n    width: 100%;\n    border-collapse: collapse;\n    background-color: #ffffff;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    th,\n    td {\n      padding: 8px 12px;\n      text-align: center;\n      font-size: 14px;\n      border: 1px solid #e0e0e0;\n\n      input {\n        height: 20px;\n        width: 40px;\n        /* Уменьшенный размер для инпутов */\n        padding: 4px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n        font-size: 14px;\n        box-sizing: border-box;\n      }\n    }\n\n    thead {\n      background-color: $primary-color !important;\n      color: #ffffff;\n      font-weight: bold;\n\n      th {\n        padding-right: 40px;\n        padding: 5px;\n\n        /* Добавлено место для иконок */\n        .head-name {\n          display: flex;\n        }\n\n        .clip-icon {\n          margin: 2px;\n        }\n      }\n    }\n\n    .positive-column {\n      background-color: #d4edda;\n      /* Светло-зелёный фон */\n    }\n\n    .negative-column {\n      background-color: #edd4d4;\n      /* Светло-зелёный фон */\n    }\n\n    tbody tr:hover .positive-column {\n      background-color: #9cff9c; // Более светлый цвет для positive-column при наведении\n      /* Или другой цвет для negative-column при наведении */\n    }\n\n    tbody tr:hover .negative-column {\n      background-color: #ff9e9e; // Более светлый цвет для positive-column при наведении\n      /* Или другой цвет для negative-column при наведении */\n    }\n\n    tbody {\n      tr {\n        &:nth-child(even) {\n          background-color: #fafafa;\n        }\n\n        &:hover {\n          background-color: #f1f1f1 !important;\n        }\n\n        td {\n          padding: 0px 10px;\n\n          &:first-child {\n            text-align: left;\n            font-weight: 600;\n            white-space: nowrap;\n          }\n\n          &.weekend {\n            background-color: #ffebee;\n            color: #d32f2f;\n          }\n        }\n      }\n    }\n  }\n\n  .checkbox-container {\n    display: flex;\n    align-items: center;\n    margin: 10px 0;\n\n    input[type=\"checkbox\"] {\n      margin-right: 10px;\n    }\n  }\n\n  .legend {\n    padding: 15px;\n    border-radius: 8px;\n    background-color: #f8f9fa; // Светлый фон для легенды\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); // Тень для выделения блока\n    margin-bottom: 20px;\n\n    h3 {\n      margin-bottom: 10px;\n      font-size: 1.5rem;\n      color: #333; // Темный цвет для заголовка\n      font-weight: bold;\n    }\n\n    ul {\n      list-style-type: none; // Убираем маркеры списка\n      padding: 0;\n\n      li {\n        padding: 10px;\n        border-bottom: 1px solid #ddd; // Разделитель элементов списка\n        font-size: 1rem;\n        color: #666; // Цвет текста\n\n        &:last-child {\n          border-bottom: none; // Убираем нижний бордер у последнего элемента\n        }\n\n        &.positive {\n          color: #28a745; // Зеленый цвет для положительных значений\n        }\n\n        &.negative {\n          color: #dc3545; // Красный цвет для отрицательных значений\n        }\n      }\n    }\n  }\n}\n\n$table-bg-color: #ffffff;\n$table-header-bg-color: #f2f2f2;\n$table-header-font-color: #333;\n$table-row-font-color: #555;\n$table-row-hover-bg-color: #e9ecef;\n$table-row-alt-bg-color: #f9f9f9;\n$table-border-color: #ddd;\n$table-highlight-red-bg: rgba(255, 0, 0, 0.1);\n\n.tracking-container {\n  width: 95%;\n  box-sizing: border-box;\n\n  .tracking-header {\n    position: sticky;\n    top: 0;\n    padding: 15px;\n    background-color: $table-bg-color;\n    z-index: 100;\n    font-size: 26px;\n    font-weight: bold;\n    color: $table-header-font-color;\n    text-align: center;\n    border-bottom: 2px solid $table-border-color;\n    margin-bottom: 10px;\n  }\n\n  .tracking-wrapper {\n    width: 100%;\n    overflow-x: auto;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    background-color: $table-bg-color;\n    position: relative;\n  }\n\n  .table {\n    border-collapse: collapse;\n    width: 100%;\n    background-color: $table-bg-color;\n    border-radius: 8px;\n    table-layout: fixed; // Фиксированное распределение ширины колонок для лучшей обрезки текста\n\n    .fire-animation {\n      background-image: url(\"../../assets/images/shark.gif\");\n      background-size: contain; // или 'contain' в зависимости от ваших предпочтений\n      background-position: left;\n      background-repeat: no-repeat;\n    }\n\n    th {\n      position: sticky;\n      top: 0;\n      background-color: $table-header-bg-color;\n      padding: 12px 15px;\n      text-align: center;\n      font-weight: bold;\n      color: $table-header-font-color;\n      border-bottom: 2px solid $table-border-color;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; // Обрезка текста с многоточием\n    }\n\n    .selected-column {\n      background-color: $primary-color;\n      color: #fff;\n    }\n\n    td {\n      padding: 8px 15px;\n      text-align: left;\n      font-size: 16px;\n      border-bottom: 1px solid $table-border-color;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; // Обрезка текста с многоточием\n      max-width: 200px; // Установка максимальной ширины ячейки для контроля обрезки текста\n\n      &:first-child {\n        padding-left: 20px;\n        font-weight: bold; // Подчеркнем важность первого столбца\n      }\n\n      a {\n        color: $primary-color;\n        text-decoration: none;\n        font-weight: 500;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n\n    tr {\n      transition: background-color 0.3s ease;\n\n      &:nth-child(even) {\n        background-color: $table-row-alt-bg-color;\n      }\n\n      &:hover {\n        background-color: $table-row-hover-bg-color !important;\n      }\n\n      &.highlight-red {\n        background-color: $table-highlight-red-bg !important;\n      }\n\n      &.selected {\n        background-color: rgba(72, 255, 0, 0.1) !important;\n      }\n    }\n  }\n\n  .table-container {\n    overflow-x: auto;\n    max-height: 100%;\n    position: relative;\n  }\n}\n\n.statistics-container {\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 12px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n\n  h2 {\n    margin-bottom: 20px;\n    font-size: 1.5rem;\n    color: #333;\n  }\n\n  .statistics-table-wrapper {\n    max-height: 200px;\n    /* Ограничиваем высоту контейнера */\n    overflow-y: auto;\n    border-radius: 20px;\n\n    /* Вертикальная прокрутка */\n    .statistics-table {\n      border-collapse: collapse;\n      border-spacing: 0;\n      table-layout: fixed;\n      /* Устанавливает фиксированное распределение ширины колонок */\n      width: 100%;\n      background-color: #ffffff;\n\n      th {\n        background-color: #ffffff;\n        position: sticky;\n        top: 0;\n        padding: 14px;\n        text-align: center;\n        font-weight: bold;\n        color: #333;\n        white-space: nowrap;\n        overflow: hidden;\n        position: relative;\n        /* Необходимо для псевдоэлемента */\n        z-index: 2;\n        overflow: hidden;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          right: 0;\n          width: 20px;\n          /* Ширина градиента */\n          height: 100%;\n          background: linear-gradient(\n            to right,\n            rgba(255, 255, 255, 0) 0%,\n            rgb(255, 255, 255) 100%\n          );\n          pointer-events: none;\n          /* Не мешает взаимодействию с текстом */\n        }\n\n        .resizer-area {\n          cursor: e-resize;\n          position: absolute;\n          right: 0;\n          top: 10%;\n          width: 2px;\n          height: 80%;\n          z-index: 1;\n          transition: background-color 0.2s ease;\n          background-color: rgba(0, 0, 0, 0.1);\n\n          &:hover {\n            background-color: rgba(0, 0, 0, 0.2);\n          }\n        }\n\n        &.selected-column {\n          background-color: $primary-color;\n          color: #ffffff;\n\n          &::after {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            right: 0;\n            width: 20px;\n            /* Ширина градиента */\n            height: 100%;\n            background: linear-gradient(\n              to right,\n              rgba(255, 255, 255, 0) 0%,\n              $primary-color 100%\n            );\n            pointer-events: none;\n            /* Не мешает взаимодействию с текстом */\n          }\n        }\n      }\n\n      tr {\n        transition: background-color 0.3s ease;\n\n        &:nth-child(even) {\n          background-color: #f9f9f9;\n        }\n\n        &:hover {\n          background-color: #e9ecef !important;\n        }\n\n        &.selected {\n          background-color: rgba(72, 255, 0, 0.1) !important;\n        }\n\n        &.highlight-red {\n          background-color: rgba(255, 0, 0, 0.1);\n        }\n\n        &.fire-animation {\n          background-image: url(\"../../assets/images/shark.gif\");\n          background-size: contain; // или 'contain' в зависимости от ваших предпочтений\n          background-position: left;\n          background-repeat: no-repeat;\n        }\n      }\n\n      td {\n        padding: 6px;\n        font-size: 16px;\n        color: transparent;\n        /* Делаем цвет текста прозрачным для отображения градиента */\n        background: linear-gradient(\n          to right,\n          #000 0%,\n          #000 80%,\n          rgba(85, 85, 85, 0) 100%\n        );\n        /* Градиентный фон от серого к прозрачному */\n        -webkit-background-clip: text;\n        /* Для Chrome и Safari */\n        background-clip: text;\n        /* Стандартное свойство для других браузеров */\n        position: relative;\n        max-width: 30px;\n        min-width: 20px;\n        overflow: hidden;\n        /* Убедитесь, что текст не вылезает из контейнера */\n        white-space: nowrap;\n        /* Запрещаем перенос строк */\n      }\n\n      td:first-child {\n        padding-left: 20px;\n      }\n\n      a {\n        color: #007bff;\n        /* Пример цветовой переменной */\n        text-decoration: none;\n        font-weight: 500;\n      }\n\n      a:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n/* Обертка для кнопки \"Лайк\" */\n.like-container {\n  position: absolute;\n  right: 10px;\n  /* Отступ от правого края */\n  bottom: 5px;\n  /* Отступ от нижнего края */\n  display: flex;\n  align-items: center;\n  /* Вертикально центрируем кнопку */\n}\n\n/* Стили для кнопки \"Лайк\" */\n.like-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  /* Размер иконки */\n  color: #ccc;\n  transition: color 0.3s ease;\n}\n\n.like-button.liked .fa-heart {\n  color: red;\n  /* Цвет заполненного сердечка */\n}\n\n.like-button .fa-heart {\n  color: #ccc;\n  /* Цвет пустого сердечка */\n}\n\n.like-button:hover .fa-heart {\n  color: #ff6b6b;\n  /* Цвет сердечка при наведении */\n}\n\n.service-management {\n  p {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 0.8em;\n    color: #333;\n  }\n\n  .service-header {\n    display: grid;\n    grid-template-columns: 1fr 100px 150px 50px;\n    gap: 10px;\n    align-items: center;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 8px;\n    margin-bottom: 15px;\n\n    .service-header-item {\n      font-weight: 600;\n      color: #555;\n      font-size: 14px;\n    }\n  }\n\n  .service-item {\n    display: grid;\n    grid-template-columns: 1fr 100px 150px 50px;\n    gap: 10px;\n    align-items: center;\n    margin-bottom: 8px;\n    padding: 8px 10px;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    background-color: #ffffff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n\n    &.approved {\n      background-color: #f0f0f0;\n      /* Серый фон для подтвержденных услуг */\n      border-color: #d0d0d0;\n      box-shadow: none;\n    }\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);\n    }\n\n    .service-item-content {\n      display: flex;\n      align-items: center;\n      color: #444;\n      font-size: 14px;\n\n      /* Основной контейнер для кастомного селектора */\n      .select-wrapper {\n        position: relative;\n        width: 100%;\n        font-size: 14px;\n        border: 1px solid #ddd;\n        border-radius: 6px;\n        background-color: #ffffff;\n        color: #444;\n        padding: 8px 12px;\n        padding-right: 30px;\n        /* Добавляем отступ справа, чтобы стрелка не накладывалась на текст */\n        transition: border-color 0.3s ease, box-shadow 0.3s ease;\n\n        /* Убираем стандартное оформление */\n        appearance: none;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n\n        &:focus {\n          border-color: #007bff;\n          box-shadow: 0 0 8px rgba(0, 123, 255, 0.2);\n          outline: none;\n        }\n\n        /* Кастомный стрелочный индикатор */\n        &::after {\n          content: \"▼\";\n          position: absolute;\n          right: 12px;\n          /* Расположение стрелки */\n          top: 50%;\n          transform: translateY(-50%);\n          color: #007bff;\n          font-size: 14px;\n          pointer-events: none;\n          /* Стрелка не мешает кликам */\n        }\n\n        select {\n          width: 100%;\n          height: 100%;\n          border: none;\n          background: transparent;\n          color: inherit;\n          font-size: inherit;\n          line-height: inherit;\n          padding: 8px 12px;\n          padding-right: 30px;\n          /* Совпадает с отступом справа у контейнера */\n          cursor: pointer;\n          position: relative;\n          z-index: 2;\n          appearance: none;\n          -webkit-appearance: none;\n          -moz-appearance: none;\n        }\n      }\n\n      /* Стили для опций при открытии кастомного селектора */\n      .custom-select-menu {\n        display: none;\n        position: absolute;\n        top: calc(100% + 8px);\n        left: 0;\n        right: 0;\n        border: 1px solid #ddd;\n        border-radius: 6px;\n        background-color: #fff;\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n        max-height: 200px;\n        overflow-y: auto;\n        z-index: 10;\n      }\n\n      /* Показ меню при открытии */\n      .custom-select-menu.open {\n        display: block;\n      }\n\n      /* Стили для каждой опции в кастомном списке */\n      .custom-select-menu .custom-option {\n        padding: 8px 12px;\n        color: #444;\n        font-size: 14px;\n        cursor: pointer;\n        transition: background-color 0.2s ease;\n      }\n\n      /* Стили для опций при наведении */\n      .custom-select-menu .custom-option:hover {\n        background-color: #f0f0f0;\n      }\n    }\n\n    .input-field {\n      width: 50%;\n      padding: 4px 6px;\n      height: 100%;\n      font-size: 14px;\n      border: 1px solid #ddd;\n      border-radius: 4px;\n      background-color: #fff;\n      /* Явный фон для инпутов */\n    }\n\n    .input-field:disabled {\n      background-color: #f9f9f9;\n      /* Цвет фона для неактивных инпутов */\n      border-color: #ccc;\n    }\n\n    .service-actions {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .action-buttons {\n      display: flex;\n      gap: 4px;\n      justify-content: center;\n      align-items: center;\n      max-width: 50px;\n    }\n\n    .icon-button {\n      background: none;\n      border: none;\n      cursor: pointer;\n      font-size: 18px;\n      color: #666;\n      padding: 2px;\n      transition: color 0.2s ease, transform 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .icon-button:hover {\n      color: #0056b3;\n      transform: scale(1.1);\n    }\n\n    .icon-button:disabled {\n      color: #ccc;\n      /* Цвет иконки для неактивных кнопок */\n      cursor: not-allowed;\n    }\n\n    .confirm-button {\n      color: #28a745;\n    }\n\n    .confirm-button.disabled {\n      color: #ddd;\n      /* Цвет для неактивной кнопки подтверждения */\n    }\n\n    .confirm-button.disabled-icon {\n      color: #ddd;\n      /* Цвет иконки для неактивной кнопки подтверждения */\n    }\n\n    .delete-button i {\n      color: #ff4d4d;\n    }\n\n    .add-service-button i {\n      color: #007bff;\n      font-size: 24px;\n    }\n  }\n}\n\n.side-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0); // Начальный фон прозрачный\n  transition: background-color 0.3s ease;\n  display: flex;\n  justify-content: flex-start; // Начальное расположение контента слева\n  z-index: 3000;\n  overflow: hidden;\n  pointer-events: none; // Запрещаем клики по модалке, пока она не активна\n\n  &.active {\n    background-color: rgba(0, 0, 0, 0.4); // Полупрозрачный фон при активации\n    pointer-events: all; // Разрешаем клики по активной модалке\n  }\n\n  &__content {\n    width: 40%;\n    height: 96%;\n    margin: 1%;\n    background: #fff; // Белый фон для содержимого модального окна\n    padding: 30px 20px;\n    border-radius: 20px;\n    box-shadow: 2px 0 15px rgba(0, 0, 0, 0.2);\n    overflow-y: auto;\n    max-height: 100%;\n    position: relative;\n    transform: translateX(-100%); // Изначальное положение за пределами экрана\n    transition: transform 0.3s ease, opacity 0.3s ease; // Переход для плавного исчезновения и появления\n    opacity: 0;\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n\n    .side-modal.active & {\n      opacity: 1;\n      transform: translateX(0); // Плавный въезд содержимого на экран\n    }\n  }\n\n  &__close {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    cursor: pointer;\n    scale: 0.8;\n    transition: scale 0.2s ease;\n\n    &:hover {\n      scale: 1;\n    }\n  }\n}\n\n.checklist-container {\n  width: 100%;\n  border-radius: 10px;\n  background-color: #ffffff;\n  font-family: \"Arial\", sans-serif;\n\n  .checkbox-container {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n    font-size: 16px;\n    color: #333;\n    position: relative;\n\n    // Скрываем стандартный чекбокс\n    .checkbox-input {\n      opacity: 0;\n      position: absolute;\n      cursor: pointer;\n      z-index: 1; // Убедитесь, что стандартный чекбокс находится ниже кастомного\n\n      // Стили для отключенного состояния чекбокса\n      &:disabled {\n        cursor: not-allowed;\n      }\n    }\n\n    // Кастомный чекбокс\n    .checkmark {\n      width: 24px; // Размер кастомного чекбокса\n      height: 24px;\n      border: 1px solid #ccc; // Цвет обводки по умолчанию\n      border-radius: 50%; // Круглая форма\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: background-color 0.3s ease, border-color 0.3s ease,\n        box-shadow 0.3s ease; // Плавные переходы\n      margin-right: 12px; // Расстояние между чекбоксом и текстом\n\n      // Галочка\n      &::after {\n        content: \"\";\n        position: absolute;\n        display: none; // Галочка скрыта по умолчанию\n        width: 8px;\n        height: 16px;\n        border: solid #fff; // Цвет галочки\n        border-width: 0 2px 2px 0;\n        transform: rotate(45deg);\n        top: 40%;\n        left: 50%;\n        transform: translate(-50%, -50%) rotate(45deg); // Центрирование и поворот галочки\n      }\n    }\n\n    // Когда чекбокс выбран\n    .checkbox-input:checked + .checkmark {\n      background-color: #007bff; // Цвет фона при выборе\n      border-color: #007bff; // Цвет обводки при выборе\n      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2); // Тень для акцентирования\n\n      &::after {\n        display: block; // Показываем галочку при выборе\n      }\n    }\n\n    // Эффект при наведении\n    &:hover .checkmark {\n      background-color: #e6e6e6; // Цвет фона при наведении\n      border-color: #999; // Цвет обводки при наведении\n    }\n\n    // Стили для отключенного состояния чекбокса\n    .checkbox-input:disabled + .checkmark {\n      background-color: #f2f2f2; // Цвет фона для отключенного состояния\n      border-color: #d9d9d9; // Цвет обводки для отключенного состояния\n      cursor: not-allowed; // Меняем курсор на запрещающий\n    }\n\n    // Стили для текста\n    .checkbox-label {\n      font-size: 16px; // Размер шрифта текста\n      color: #333; // Цвет текста\n\n      // Отключенный текст\n      .checkbox-input:disabled + .checkmark + & {\n        color: #b3b3b3; // Цвет текста для отключенного состояния\n        cursor: not-allowed;\n      }\n    }\n\n    .input-check {\n      padding: 0px; // Немного больше пространства\n      width: calc(100% - 90px);\n      height: 90%;\n      border: 1px solid #ccc; // Стандартная обводка\n      border-radius: 10px; // Более закругленные углы\n      margin-right: 10px;\n      font-size: 16px;\n      transition: border-color 0.3s, box-shadow 0.3s; // Переходы для плавности\n      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); // Легкая тень для глубины\n\n      &:hover {\n        border-color: #999; // Цвет при наведении\n      }\n\n      &:focus {\n        border-color: #a1a1a1; // Цвет обводки при фокусе\n        outline: none;\n        box-shadow: 0 0 8px rgba(110, 110, 110, 0.5); // Эффект свечения при фокусе\n      }\n\n      &:disabled {\n        background-color: #f5f5f5; // Цвет фона для отключенного состояния\n        border-color: #e0e0e0; // Бледная обводка для отключенного состояния\n        cursor: not-allowed;\n      }\n    }\n\n    button {\n      padding: 8px 14px;\n      font-size: 16px;\n      border: none;\n      border-radius: 6px;\n      background-color: $primary-color;\n      color: white;\n      cursor: pointer;\n      transition: background-color 0.3s;\n\n      &:hover {\n        background-color: $primary-color;\n      }\n    }\n  }\n\n  input[type=\"text\"] {\n    width: calc(100% - 40px);\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    font-size: 16px;\n    margin-right: 10px;\n    transition: border-color 0.3s;\n\n    &:focus {\n      border-color: $primary-color;\n      outline: none;\n    }\n  }\n\n  button.add-button {\n    padding: 8px 14px;\n    font-size: 16px;\n    background-color: $primary-color;\n    border: none;\n    border-radius: 200px;\n    border: 2px solid $primary-color; // Добавляем контур с шириной 1px\n    color: white;\n    cursor: pointer;\n    transition: background-color 0.3s;\n\n    &:hover {\n      background-color: #fff;\n      color: $primary-color;\n      border: 2px solid $primary-color; // Добавляем контур с шириной 1px\n      box-shadow: 0 0 0 2px rgba($primary-color, 0.5); // Добавляем внешний контур (тень)\n    }\n  }\n}\n\n.average-time-task {\n  padding: 20px;\n  font-family: \"Roboto\", sans-serif;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.3);\n  overflow: auto;\n  max-height: 47vh;\n\n  .statistics-card {\n    background-color: #fff;\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    .stats-row {\n      display: flex;\n      justify-content: space-between;\n      padding: 10px 0;\n\n      p {\n        font-size: 16px;\n      }\n\n      .align-right {\n        margin-left: auto; // Отодвигаем вправо\n      }\n    }\n\n    h3 {\n      font-size: 18px;\n      color: #333;\n    }\n\n    .empty-state {\n      text-align: center;\n      padding: 20px;\n      color: #999;\n    }\n\n    ul {\n      list-style-type: none;\n      padding: 0;\n      margin: 1rem 0;\n\n      li {\n        font-size: 1rem;\n        padding: 0.5rem 0;\n        display: flex;\n        justify-content: space-between;\n\n        .statistic-value {\n          font-weight: 600;\n          color: #555;\n        }\n      }\n    }\n  }\n\n  .pie-chart {\n    margin-top: 20px;\n  }\n\n  .recharts-wrapper {\n    margin: 0 auto;\n  }\n\n  .recharts-tooltip-wrapper {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  }\n\n  .recharts-legend-item {\n    font-size: 14px;\n  }\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 10px;\n  padding: 10px;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.lena-style {\n  display: flex;\n  justify-content: flex-end;\n  margin: 5px;\n  @media (max-width: 768px) {\n    display: block;\n  }\n}\n.monospace {\n  font-family: \"Courier New\", Courier, monospace; /* Замените на желаемый моноширинный шрифт */\n  white-space: nowrap; /* Убедитесь, что текст не переносится */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
